import * as React from "react"

const SvgComponent = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
    <svg
        className="animated"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 500 500"
        {...props}
    >
        <g
            className="animable"
            style={{
                transformOrigin: "250px 384.61px",
            }}
        >
            <ellipse
                cx={250}
                cy={384.61}
                rx={209.73}
                ry={94.79}
                style={{
                    fill: "#f5f5f5",
                    transformOrigin: "250px 384.61px",
                }}
                className="animable"
            />
        </g>
        <g
            className="animable"
            style={{
                transformOrigin: "246.486px 400.105px",
            }}
        >
            <ellipse
                cx={352.36}
                cy={395.73}
                rx={56.05}
                ry={32.36}
                style={{
                    fill: "#e0e0e0",
                    transformOrigin: "352.36px 395.73px",
                }}
                className="animable"
            />
            <path
                d="M91.71 412.52c-9.53 5.57-9.53 14.59 0 20.15s25 5.56 34.51 0 9.53-14.58 0-20.15-24.98-5.52-34.51 0Z"
                style={{
                    fill: "#e0e0e0",
                    transformOrigin: "108.961px 422.601px",
                }}
                className="animable"
            />
        </g>
        <g
            className="animable"
            style={{
                transformOrigin: "169.765px 254.323px",
            }}
        >
            <g
                className="animable"
                style={{
                    transformOrigin: "169.765px 221.269px",
                }}
            >
                <path
                    d="M103.87 225.91v3.46c0 1.09.77 1.53 1.71 1l3.34-1.92V221l-3.34 2a3.78 3.78 0 0 0-1.71 2.91Z"
                    style={{
                        fill: "#e0e0e0",
                        transformOrigin: "106.395px 225.797px",
                    }}
                    className="animable"
                />
                <path
                    d="M93.28 223v3.45c0 1.09.77 1.53 1.71 1l13.93-8V212L95 220a3.78 3.78 0 0 0-1.72 3Z"
                    style={{
                        fill: "#e0e0e0",
                        transformOrigin: "101.1px 219.837px",
                    }}
                    className="animable"
                />
                <path
                    d="M100.82 262.05 85 271.18a3.8 3.8 0 0 0-1.71 3v3.46c0 1.09.77 1.53 1.71 1l15.82-9.13a3.78 3.78 0 0 0 1.71-3V263c0-1.06-.77-1.5-1.71-.95Z"
                    style={{
                        fill: "#e0e0e0",
                        transformOrigin: "92.91px 270.338px",
                    }}
                    className="animable"
                />
                <path
                    d="m108.92 302.88-13.93 8a3.78 3.78 0 0 0-1.71 3v3.46c0 1.09.77 1.53 1.71 1l13.93-8Z"
                    style={{
                        fill: "#e0e0e0",
                        transformOrigin: "101.1px 310.722px",
                    }}
                    className="animable"
                />
                <path
                    d="M93.28 186.59V190c0 1.09.77 1.53 1.71 1l13.93-8v-7.4l-13.93 8a3.78 3.78 0 0 0-1.71 2.99Z"
                    style={{
                        fill: "#e0e0e0",
                        transformOrigin: "101.1px 183.412px",
                    }}
                    className="animable"
                />
                <path
                    d="M77.44 295.91v3.46c0 1.09.76 1.53 1.71 1L95 291.23a3.77 3.77 0 0 0 1.71-3v-3.46c0-1.09-.76-1.53-1.71-1L79.15 293a3.77 3.77 0 0 0-1.71 2.91Z"
                    style={{
                        fill: "#e0e0e0",
                        transformOrigin: "87.075px 292.07px",
                    }}
                    className="animable"
                />
                <path
                    d="M93.28 259.32v3.46c0 1.09.77 1.53 1.71 1l13.93-8v-7.41l-13.92 8a3.78 3.78 0 0 0-1.72 2.95Z"
                    style={{
                        fill: "#e0e0e0",
                        transformOrigin: "101.1px 256.187px",
                    }}
                    className="animable"
                />
                <path
                    d="M91.94 318.09v-3.45c0-1.09-.76-1.54-1.71-1l-15.82 9.13a3.8 3.8 0 0 0-1.71 3v3.46c0 1.09.77 1.53 1.71 1l15.82-9.14a3.75 3.75 0 0 0 1.71-3Z"
                    style={{
                        fill: "#e0e0e0",
                        transformOrigin: "82.32px 321.933px",
                    }}
                    className="animable"
                />
                <path
                    d="m92 176.33-15.8 9.13a3.8 3.8 0 0 0-1.71 3v3.46c0 1.09.77 1.53 1.71 1l15.8-9.18a3.8 3.8 0 0 0 1.71-3v-3.46c.02-1.05-.71-1.49-1.71-.95Z"
                    style={{
                        fill: "#e0e0e0",
                        transformOrigin: "84.1002px 184.621px",
                    }}
                    className="animable"
                />
                <path
                    d="M100.82 189.31 85 198.44a3.8 3.8 0 0 0-1.71 3v3.46c0 1.09.77 1.53 1.71 1l15.82-9.14a3.78 3.78 0 0 0 1.71-3v-3.46c0-1.1-.77-1.54-1.71-.99Z"
                    style={{
                        fill: "#e0e0e0",
                        transformOrigin: "92.91px 197.599px",
                    }}
                    className="animable"
                />
                <path
                    d="M100.82 225.68 85 234.81a3.8 3.8 0 0 0-1.71 3v3.46c0 1.09.77 1.53 1.71 1l15.82-9.13a3.78 3.78 0 0 0 1.71-3v-3.46c0-1.11-.77-1.55-1.71-1Z"
                    style={{
                        fill: "#e0e0e0",
                        transformOrigin: "92.91px 233.969px",
                    }}
                    className="animable"
                />
                <path
                    d="m85 333.14 15.82-9.14a3.8 3.8 0 0 0 1.71-3v-3.46c0-1.09-.77-1.53-1.71-1L85 325.73a3.8 3.8 0 0 0-1.71 3v3.46c0 1.05.77 1.49 1.71.95Z"
                    style={{
                        fill: "#e0e0e0",
                        transformOrigin: "92.91px 324.844px",
                    }}
                    className="animable"
                />
                <path
                    d="M235.65 161.92v3.46a3.77 3.77 0 0 1-1.7 3l-3.34 1.93v-7.41l3.34-1.92c.94-.59 1.7-.15 1.7.94Z"
                    style={{
                        fill: "#e0e0e0",
                        transformOrigin: "233.13px 165.513px",
                    }}
                    className="animable"
                />
                <path
                    d="m230.61 281.09 13.93-8c.94-.55 1.7-.1 1.7 1v3.45a3.77 3.77 0 0 1-1.7 3l-13.93 8Z"
                    style={{
                        fill: "#e0e0e0",
                        transformOrigin: "238.425px 280.698px",
                    }}
                    className="animable"
                />
                <path
                    d="M246.24 146.74v3.46a3.79 3.79 0 0 1-1.7 3l-13.93 8v-7.4l13.93-8c.94-.59 1.7-.15 1.7.94Z"
                    style={{
                        fill: "#e0e0e0",
                        transformOrigin: "238.425px 153.368px",
                    }}
                    className="animable"
                />
                <path
                    d="m238.71 194.54 15.82-9.14c.94-.54 1.71-.1 1.71 1v3.46a3.8 3.8 0 0 1-1.71 3l-15.82 9.13c-1 .55-1.71.1-1.71-1v-3.49a3.75 3.75 0 0 1 1.71-2.96Z"
                    style={{
                        fill: "#e0e0e0",
                        transformOrigin: "246.62px 193.697px",
                    }}
                    className="animable"
                />
                <path
                    d="m230.61 244.72 13.93-8c.94-.54 1.7-.1 1.7 1v3.45a3.77 3.77 0 0 1-1.7 3l-13.93 8Z"
                    style={{
                        fill: "#e0e0e0",
                        transformOrigin: "238.425px 244.33px",
                    }}
                    className="animable"
                />
                <path
                    d="M246.24 110.37v3.46a3.77 3.77 0 0 1-1.7 3l-13.93 8v-7.4l13.93-8c.94-.59 1.7-.15 1.7.94Z"
                    style={{
                        fill: "#e0e0e0",
                        transformOrigin: "238.425px 116.998px",
                    }}
                    className="animable"
                />
                <path
                    d="M262.09 201.4v3.46a3.77 3.77 0 0 1-1.71 3L244.56 217c-.94.55-1.7.11-1.7-1v-3.46a3.77 3.77 0 0 1 1.7-3l15.82-9.13c.95-.54 1.71-.1 1.71.99Z"
                    style={{
                        fill: "#e0e0e0",
                        transformOrigin: "252.475px 208.708px",
                    }}
                    className="animable"
                />
                <path
                    d="M246.24 183.11v3.46a3.79 3.79 0 0 1-1.7 3l-13.93 8v-7.4l13.93-8c.94-.59 1.7-.17 1.7.94Z"
                    style={{
                        fill: "#e0e0e0",
                        transformOrigin: "238.425px 189.736px",
                    }}
                    className="animable"
                />
                <path
                    d="M247.59 240.33v-3.46a3.77 3.77 0 0 1 1.71-3l15.82-9.13c.94-.55 1.71-.11 1.71 1v3.46a3.78 3.78 0 0 1-1.71 3l-15.82 9.14c-.95.52-1.71.08-1.71-1.01Z"
                    style={{
                        fill: "#e0e0e0",
                        transformOrigin: "257.21px 233.031px",
                    }}
                    className="animable"
                />
                <path
                    d="m238.71 121.8 15.82-9.14c.94-.54 1.71-.1 1.71 1v3.46a3.8 3.8 0 0 1-1.71 3l-15.82 9.13c-1 .55-1.71.1-1.71-1v-3.46a3.75 3.75 0 0 1 1.71-2.99Z"
                    style={{
                        fill: "#e0e0e0",
                        transformOrigin: "246.62px 120.957px",
                    }}
                    className="animable"
                />
                <path
                    d="m238.71 158.17 15.82-9.17c.94-.54 1.71-.1 1.71 1v3.46a3.8 3.8 0 0 1-1.71 3l-15.82 9.13c-1 .55-1.71.1-1.71-1v-3.45a3.75 3.75 0 0 1 1.71-2.97Z"
                    style={{
                        fill: "#e0e0e0",
                        transformOrigin: "246.62px 157.297px",
                    }}
                    className="animable"
                />
                <path
                    d="m254.53 247.36-15.82 9.14c-1 .54-1.71.1-1.71-1v-3.46a3.77 3.77 0 0 1 1.71-3l15.82-9.04c.94-.55 1.71-.1 1.71 1v3.46a3.78 3.78 0 0 1-1.71 2.9Z"
                    style={{
                        fill: "#e0e0e0",
                        transformOrigin: "246.62px 248.248px",
                    }}
                    className="animable"
                />
                <path
                    d="m230.61 299.27 13.93-8c.94-.54 1.7-.1 1.7 1v3.46a3.79 3.79 0 0 1-1.7 3l-13.93 8Z"
                    style={{
                        fill: "#e0e0e0",
                        transformOrigin: "238.425px 298.885px",
                    }}
                    className="animable"
                />
            </g>
            <g
                className="animable"
                style={{
                    transformOrigin: "169.771px 254.323px",
                }}
            >
                <g
                    className="animable"
                    style={{
                        transformOrigin: "169.771px 254.323px",
                    }}
                >
                    <path
                        d="M108.92 413V165.44a12 12 0 0 1 5.42-9.38l107.12-61.85a3.83 3.83 0 0 1 3.83-.38L229 96a3.79 3.79 0 0 1 1.6 3.51v247.55l-7.81 4.51-6.34-3.67-96 55.42v7.33l-7.81 4.51Z"
                        style={{
                            fill: "#37474f",
                            transformOrigin: "169.771px 254.323px",
                        }}
                        className="animable"
                    />
                    <path
                        d="m134.28 395.32-13.85 8v7.33l-7.81 4.51-3.7-2.14V165.44a11 11 0 0 1 1.6-5.35l23.58 13.62Z"
                        style={{
                            fill: "#263238",
                            transformOrigin: "121.6px 287.625px",
                        }}
                        className="animable"
                    />
                    <path
                        d="M112.62 167.59v247.55l7.81-4.5v-7.32l96-55.42 6.34 3.66 7.81-4.5V99.48c0-3.47-2.43-4.85-5.4-3.13L118 158.21a12 12 0 0 0-5.38 9.38Z"
                        style={{
                            fill: "#455a64",
                            transformOrigin: "171.6px 255.376px",
                        }}
                        className="animable"
                    />
                    <path
                        style={{
                            fill: "#975ac2",
                            transformOrigin: "169.765px 259.165px",
                        }}
                        className="animable"
                        d="M120.43 168.9v237.48l98.67-56.96V111.95l-98.67 56.95z"
                    />
                    <path
                        style={{
                            fill: "#fff",
                            opacity: 0.7,
                            transformOrigin: "169.765px 259.165px",
                        }}
                        className="animable"
                        d="M120.43 168.9v237.48l98.67-56.96V111.95l-98.67 56.95z"
                    />
                    <g
                        style={{
                            opacity: 0.43,
                            transformOrigin: "169.75px 259.165px",
                        }}
                        className="animable"
                    >
                        <path
                            d="M137.25 377.26V178.61l65-37.54v198.64ZM140 180.19v192.34l59.59-34.4V145.8Z"
                            style={{
                                fill: "#975ac2",
                                transformOrigin: "169.75px 259.165px",
                            }}
                            className="animable"
                        />
                        <path
                            d="M137.25 178.61v198.65l65-37.55V141.07Zm62.31 159.52L140 372.53V180.19l59.59-34.39Z"
                            style={{
                                opacity: 0.1,
                                transformOrigin: "169.75px 259.165px",
                            }}
                            className="animable"
                        />
                    </g>
                    <path
                        style={{
                            fill: "#263238",
                            transformOrigin: "220.93px 230.7px",
                        }}
                        className="animable"
                        d="M219.1 349.42V111.95l3.65-2.12.01 241.74-3.66-2.15z"
                    />
                    <path
                        style={{
                            fill: "#e0e0e0",
                            transformOrigin: "171.595px 380.03px",
                        }}
                        className="animable"
                        d="m120.43 410.64 102.33-59.07-3.66-2.15-98.67 56.96v4.26z"
                    />
                </g>
                <g
                    className="animable"
                    style={{
                        transformOrigin: "137.245px 271.895px",
                    }}
                >
                    <path
                        style={{
                            fill: "#e0e0e0",
                            transformOrigin: "123.33px 275.155px",
                        }}
                        className="animable"
                        d="m122.34 258.22 1.97 1.14.01 32.73-1.98-1.14v-32.73z"
                    />
                    <path
                        style={{
                            fill: "#fafafa",
                            transformOrigin: "129.63px 272.655px",
                        }}
                        className="animable"
                        d="m124.31 259.36 10.63-6.14.01 32.73-10.63 6.14-.01-32.73z"
                    />
                    <path
                        d="m135 262.23-4.66 2.68v5.32a.64.64 0 0 0 1 .55l3.7-2.13Z"
                        style={{
                            opacity: 0.05,
                            transformOrigin: "132.69px 266.561px",
                        }}
                        className="animable"
                    />
                    <path
                        style={{
                            fill: "#ebebeb",
                            transformOrigin: "128.64px 255.72px",
                        }}
                        className="animable"
                        d="m134.94 253.22-1.97-1.14-10.63 6.14 1.97 1.14 10.63-6.14z"
                    />
                    <path
                        d="m128.39 263.82 4.88 2.81 1.95-3.38-4.88-2.81a.94.94 0 0 0-1 .09 3 3 0 0 0-1.38 2.39 1 1 0 0 0 .43.9Z"
                        style={{
                            fill: "#e0e0e0",
                            transformOrigin: "131.589px 263.483px",
                        }}
                        className="animable"
                    />
                    <path
                        style={{
                            opacity: 0.1,
                            transformOrigin: "132.12px 263.72px",
                        }}
                        className="animable"
                        d="m130.29 264.91 1.77 1.03v-2.33l1.89-1.09-1.77-1.02-1.89 1.08v2.33z"
                    />
                    <path
                        style={{
                            fill: "#fafafa",
                            transformOrigin: "142.4px 260.91px",
                        }}
                        className="animable"
                        d="M132.65 263.98v5.11l19.5-11.25v-5.11l-19.5 11.25z"
                    />
                    <path
                        style={{
                            fill: "#e0e0e0",
                            transformOrigin: "131.765px 266.02px",
                        }}
                        className="animable"
                        d="m132.65 263.98-1.77-1.03v5.12l1.77 1.02v-5.11z"
                    />
                    <path
                        style={{
                            fill: "#ebebeb",
                            transformOrigin: "141.515px 257.84px",
                        }}
                        className="animable"
                        d="m152.15 252.73-1.77-1.03-19.5 11.25 1.77 1.03 19.5-11.25z"
                    />
                    <path
                        d="M127.84 278.23a4 4 0 0 1 1.79-3.1c1-.57 1.79-.11 1.79 1a3.92 3.92 0 0 1-1.08 2.52V282a1.35 1.35 0 0 1-.61 1.05l-.2.12c-.34.19-.61 0-.61-.35v-3.34c-.64.08-1.08-.4-1.08-1.25Z"
                        style={{
                            fill: "#455a64",
                            transformOrigin: "129.63px 279.065px",
                        }}
                        className="animable"
                    />
                </g>
                <g
                    className="animable"
                    style={{
                        transformOrigin: "171.11px 200.078px",
                    }}
                >
                    <path
                        d="m155.5 200.16 30.07-17.36c1.79-1 3.25-.2 3.25 1.87v20.65a7.21 7.21 0 0 1-3.25 5.63l-30.07 17.36c-1.79 1-3.25.19-3.25-1.88v-20.65a7.17 7.17 0 0 1 3.25-5.62Z"
                        style={{
                            opacity: 0.15,
                            transformOrigin: "170.535px 205.554px",
                        }}
                        className="animable"
                    />
                    <path
                        d="m156.65 201 30.07-17.36c1.79-1 3.25-.2 3.25 1.87v20.65a7.21 7.21 0 0 1-3.25 5.63l-30.07 17.36c-1.8 1-3.25.19-3.25-1.88v-20.61a7.15 7.15 0 0 1 3.25-5.66Z"
                        style={{
                            fill: "#455a64",
                            transformOrigin: "171.685px 206.394px",
                        }}
                        className="animable"
                    />
                    <path
                        d="M165.59 198h-.08a.37.37 0 0 1-.29-.45l6.1-26.68a.36.36 0 0 1 .35-.29.37.37 0 0 1 .36.26l6.1 19.65a.38.38 0 1 1-.72.22l-5.68-18.31-5.73 25.34a.38.38 0 0 1-.41.26Z"
                        style={{
                            fill: "#263238",
                            transformOrigin: "171.687px 184.292px",
                        }}
                        className="animable"
                    />
                    <path
                        d="M157.66 220.88a.72.72 0 0 1-.09-.44v-10.81a1.37 1.37 0 0 1 .09-.55.58.58 0 0 1 .29-.31l3.27-1.89c.11-.06.18 0 .23.05a1.51 1.51 0 0 1 .06.52v.45a2.41 2.41 0 0 1-.06.6.5.5 0 0 1-.23.31l-2.16 1.25v3L161 212c.1-.06.18 0 .22.05a1.3 1.3 0 0 1 .07.53v.42a1.89 1.89 0 0 1-.07.6.55.55 0 0 1-.22.32l-1.94 1.08v3.28l2.17-1.26a.15.15 0 0 1 .22 0 1.54 1.54 0 0 1 .06.53v.45a2.34 2.34 0 0 1-.06.61.54.54 0 0 1-.22.3l-3.28 1.9c-.14.12-.24.13-.29.07Z"
                        style={{
                            fill: "#fafafa",
                            transformOrigin: "159.539px 213.885px",
                        }}
                        className="animable"
                    />
                    <path
                        d="M162.78 217.6v-11a1.19 1.19 0 0 1 .1-.53.72.72 0 0 1 .29-.33l1.81-1q2.25-1.31 2.25 2a5.9 5.9 0 0 1-1 3.53v.07c.3.08.55.56.76 1.44l.68 2.95a.44.44 0 0 0 0 .1.34.34 0 0 1 0 .1c0 .27-.2.52-.61.75l-.32.19c-.35.2-.55.18-.58-.06l-.62-3a1.21 1.21 0 0 0-.31-.64c-.12-.08-.29-.05-.53.09l-.42.24v4.26a1 1 0 0 1-.59.85l-.31.17c-.38.22-.6.15-.6-.18Zm2.28-7.69a1.4 1.4 0 0 0 .51-.76 3.86 3.86 0 0 0 .22-1.37 2 2 0 0 0-.21-1.1q-.21-.27-.57-.06l-.76.44v3.32Z"
                        style={{
                            fill: "#fafafa",
                            transformOrigin: "165.226px 211.138px",
                        }}
                        className="animable"
                    />
                    <path
                        d="M168.65 214.21v-11a1.38 1.38 0 0 1 .09-.54.8.8 0 0 1 .3-.33l1.81-1q2.25-1.31 2.25 2a5.94 5.94 0 0 1-1 3.53v.06c.3.09.55.57.76 1.45l.67 2.94V211.53c0 .26-.2.51-.61.74l-.32.19c-.36.2-.55.18-.59-.06l-.61-3a1.19 1.19 0 0 0-.31-.63c-.12-.08-.3-.06-.54.08l-.41.24v4.27a1 1 0 0 1-.6.84l-.3.18c-.4.22-.59.17-.59-.17Zm2.28-7.69a1.36 1.36 0 0 0 .51-.76 4.07 4.07 0 0 0 .21-1.37 1.92 1.92 0 0 0-.2-1.09.39.39 0 0 0-.57-.07l-.76.44V207Z"
                        style={{
                            fill: "#fafafa",
                            transformOrigin: "171.09px 207.741px",
                        }}
                        className="animable"
                    />
                    <path
                        d="M174.29 205.36q0-6.15 2.89-7.82t2.89 4.48q0 6.18-2.89 7.85t-2.89-4.51Zm3.93 1a13.59 13.59 0 0 0 .33-3.46 9.2 9.2 0 0 0-.33-3.07q-.33-.77-1-.36a2.49 2.49 0 0 0-1 1.56 13.45 13.45 0 0 0-.33 3.45 9.36 9.36 0 0 0 .33 3.08c.23.52.57.64 1 .37a2.55 2.55 0 0 0 1-1.57Z"
                        style={{
                            fill: "#fafafa",
                            transformOrigin: "177.18px 203.704px",
                        }}
                        className="animable"
                    />
                    <path
                        d="M181.35 206.88v-11a1.38 1.38 0 0 1 .09-.54.68.68 0 0 1 .3-.33l1.8-1q2.27-1.31 2.26 2a5.94 5.94 0 0 1-1.05 3.53v.06c.29.09.55.57.76 1.45l.67 2.94a.3.3 0 0 1 0 .1.41.41 0 0 1 0 .11c0 .26-.2.51-.6.74l-.33.19c-.35.2-.54.18-.58-.06l-.62-3a1.13 1.13 0 0 0-.31-.63c-.11-.09-.29-.06-.53.08l-.41.24V206a1 1 0 0 1-.6.84l-.3.17c-.36.26-.55.2-.55-.13Zm2.27-7.69a1.32 1.32 0 0 0 .52-.76 4.11 4.11 0 0 0 .21-1.37 2 2 0 0 0-.21-1.1.39.39 0 0 0-.56-.06l-.76.44v3.32Z"
                        style={{
                            fill: "#fafafa",
                            transformOrigin: "183.767px 200.405px",
                        }}
                        className="animable"
                    />
                </g>
            </g>
            <g
                className="animable"
                style={{
                    transformOrigin: "169.44px 297.005px",
                }}
            >
                <path
                    style={{
                        opacity: 0.2,
                        transformOrigin: "110.68px 375.03px",
                    }}
                    className="animable"
                    d="m112.53 369.86-3.7-2.11.01 12.45 3.69 2.11v-12.45z"
                />
                <path
                    style={{
                        fill: "#975ac2",
                        transformOrigin: "110.44px 371.545px",
                    }}
                    className="animable"
                    d="m112.53 366.54-4.18-2.44.01 12.45 4.17 2.44v-12.45z"
                />
                <path
                    style={{
                        opacity: 0.2,
                        transformOrigin: "110.44px 371.545px",
                    }}
                    className="animable"
                    d="m112.53 366.54-4.18-2.44.01 12.45 4.17 2.44v-12.45z"
                />
                <path
                    style={{
                        opacity: 0.25,
                        transformOrigin: "171.53px 298.66px",
                    }}
                    className="animable"
                    d="m230.53 215.01-118 154.85.01 12.45 117.99-154.84v-12.46z"
                />
                <path
                    style={{
                        fill: "#975ac2",
                        transformOrigin: "171.53px 295.345px",
                    }}
                    className="animable"
                    d="m230.53 211.7-118 154.84.01 12.45 117.99-154.84V211.7z"
                />
                <path
                    style={{
                        fill: "#455a64",
                        transformOrigin: "225.17px 222.125px",
                    }}
                    className="animable"
                    d="M230.53 224.13v-5.65l-5.85.9-4.87 6.39 10.72-1.64z"
                />
                <path
                    style={{
                        fill: "#455a64",
                        transformOrigin: "208.12px 247.345px",
                    }}
                    className="animable"
                    d="m215.94 243.32-10.76 1.65-4.88 6.4 10.77-1.66 4.87-6.39z"
                />
                <path
                    style={{
                        fill: "#455a64",
                        transformOrigin: "217.87px 234.545px",
                    }}
                    className="animable"
                    d="m225.69 230.52-10.76 1.65-4.88 6.4 10.77-1.65 4.87-6.4z"
                />
                <path
                    style={{
                        fill: "#455a64",
                        transformOrigin: "198.37px 260.135px",
                    }}
                    className="animable"
                    d="m206.19 256.11-10.76 1.66-4.88 6.39 10.77-1.65 4.87-6.4z"
                />
                <path
                    style={{
                        fill: "#455a64",
                        transformOrigin: "188.62px 272.935px",
                    }}
                    className="animable"
                    d="m196.44 268.91-10.77 1.65-4.87 6.4 10.76-1.65 4.88-6.4z"
                />
                <path
                    style={{
                        fill: "#455a64",
                        transformOrigin: "178.87px 285.735px",
                    }}
                    className="animable"
                    d="m186.69 281.71-10.77 1.65-4.87 6.4 10.76-1.65 4.88-6.4z"
                />
                <path
                    style={{
                        fill: "#455a64",
                        transformOrigin: "169.115px 298.525px",
                    }}
                    className="animable"
                    d="m176.94 294.5-10.77 1.66-4.88 6.39 10.77-1.65 4.88-6.4z"
                />
                <path
                    style={{
                        fill: "#455a64",
                        transformOrigin: "159.36px 311.325px",
                    }}
                    className="animable"
                    d="m167.18 307.3-10.76 1.65-4.88 6.4 10.77-1.65 4.87-6.4z"
                />
                <path
                    style={{
                        fill: "#455a64",
                        transformOrigin: "149.61px 324.125px",
                    }}
                    className="animable"
                    d="m157.43 320.1-10.76 1.65-4.88 6.4 10.77-1.65 4.87-6.4z"
                />
                <path
                    style={{
                        fill: "#455a64",
                        transformOrigin: "139.86px 336.915px",
                    }}
                    className="animable"
                    d="m147.68 332.89-10.77 1.66-4.87 6.39 10.77-1.65 4.87-6.4z"
                />
                <path
                    style={{
                        fill: "#455a64",
                        transformOrigin: "130.11px 349.715px",
                    }}
                    className="animable"
                    d="m137.93 345.69-10.77 1.65-4.87 6.4 10.76-1.65 4.88-6.4z"
                />
                <path
                    style={{
                        fill: "#455a64",
                        transformOrigin: "120.355px 362.515px",
                    }}
                    className="animable"
                    d="m128.18 358.49-10.77 1.65-4.88 6.4 10.77-1.66 4.88-6.39z"
                />
                <path
                    style={{
                        fill: "#455a64",
                        transformOrigin: "115.47px 375.14px",
                    }}
                    className="animable"
                    d="m118.41 371.29-5.88.9v6.8l1-1.31 4.88-6.39z"
                />
                <path
                    style={{
                        opacity: 0.25,
                        transformOrigin: "171.53px 297.45px",
                    }}
                    className="animable"
                    d="m112.53 283.52 118 15.41v12.45l-118-15.4v-12.46z"
                />
                <path
                    style={{
                        fill: "#975ac2",
                        transformOrigin: "171.53px 295.345px",
                    }}
                    className="animable"
                    d="m112.53 281.42 118 15.4v12.45l-118-15.4v-12.45z"
                />
                <path
                    style={{
                        opacity: 0.2,
                        transformOrigin: "110.68px 288.66px",
                    }}
                    className="animable"
                    d="m112.53 283.52-3.7-2.17.01 12.46 3.69 2.16v-12.45z"
                />
                <path
                    style={{
                        fill: "#975ac2",
                        transformOrigin: "110.44px 286.42px",
                    }}
                    className="animable"
                    d="m112.53 281.42-4.18-2.45.01 12.46 4.17 2.44v-12.45z"
                />
                <path
                    style={{
                        opacity: 0.2,
                        transformOrigin: "110.44px 286.42px",
                    }}
                    className="animable"
                    d="m112.53 281.42-4.18-2.45.01 12.46 4.17 2.44v-12.45z"
                />
                <path
                    d="M117.8 284.78s.06 0 .07.09a.54.54 0 0 1 0 .22l-.17 1.15a.52.52 0 0 1-.06.2c0 .06-.07.08-.1.08l-1.34-.17-.22 1.48 1.25.16s.06 0 .08.1a.74.74 0 0 1 0 .21l-.17 1.16a.66.66 0 0 1-.06.2s-.07.08-.1.07l-1.25-.16-.34 2.35a.77.77 0 0 1-.07.2c0 .06-.07.09-.1.08l-.59-.07-.07-.1a.49.49 0 0 1 0-.21l1-7a.59.59 0 0 1 .06-.2s.07-.08.1-.08Z"
                    style={{
                        fill: "#37474f",
                        transformOrigin: "116.215px 288.371px",
                    }}
                    className="animable"
                />
                <path
                    d="M118.2 287.72a7.33 7.33 0 0 1 .27-1.14 4.74 4.74 0 0 1 .41-.9 1.83 1.83 0 0 1 .53-.57.8.8 0 0 1 .59-.11.81.81 0 0 1 .55.31 1.82 1.82 0 0 1 .35.68 4.55 4.55 0 0 1 .13 1 7.67 7.67 0 0 1 0 1.16c0 .32-.09.64-.14 1s-.1.66-.15 1a7.47 7.47 0 0 1-.27 1.13 4.85 4.85 0 0 1-.41.91 2 2 0 0 1-.53.57.86.86 0 0 1-.61.16.84.84 0 0 1-.56-.31 1.88 1.88 0 0 1-.34-.68 4 4 0 0 1-.13-1 7.78 7.78 0 0 1 0-1.16c0-.3.08-.62.13-1s.12-.77.18-1.05Zm1.69 2.13c0-.13 0-.28.07-.43s.06-.33.08-.49 0-.33.07-.49 0-.29 0-.42a2.9 2.9 0 0 0 0-.5 1.58 1.58 0 0 0-.05-.41.71.71 0 0 0-.13-.29.34.34 0 0 0-.48-.06.74.74 0 0 0-.22.24 2.29 2.29 0 0 0-.16.38 3.33 3.33 0 0 0-.12.5 3.86 3.86 0 0 0-.07.41c0 .16 0 .32-.08.49s0 .33-.07.49 0 .3 0 .43a2.79 2.79 0 0 0 0 .93c0 .25.17.39.36.41a.47.47 0 0 0 .46-.31 2.93 2.93 0 0 0 .34-.88Z"
                    style={{
                        fill: "#37474f",
                        transformOrigin: "119.46px 288.955px",
                    }}
                    className="animable"
                />
                <path
                    d="M123.63 285.52a1 1 0 0 1 .5.22 1.3 1.3 0 0 1 .34.51 2.92 2.92 0 0 1 .13.81 5.59 5.59 0 0 1-.07 1.11 5.42 5.42 0 0 1-.34 1.34 1.91 1.91 0 0 1-.51.77l.18 2.66v.12a.38.38 0 0 1-.06.16s0 .07-.08.07l-.61-.08a.13.13 0 0 1-.11-.12.69.69 0 0 1 0-.2l-.16-2.39-.42-.05-.34 2.32a.52.52 0 0 1-.06.2c0 .06-.07.09-.1.08l-.59-.07-.07-.1a.49.49 0 0 1 0-.21l1-7a.59.59 0 0 1 .06-.2c0-.05.07-.08.1-.08Zm-1 3.23.51.07a.37.37 0 0 0 .33-.14 1.11 1.11 0 0 0 .22-.61 1.27 1.27 0 0 0 0-.65.35.35 0 0 0-.29-.21l-.51-.07Z"
                    style={{
                        fill: "#37474f",
                        transformOrigin: "122.926px 289.34px",
                    }}
                    className="animable"
                />
                <path
                    d="M124.75 293.42a.12.12 0 0 1-.07-.1.48.48 0 0 1 0-.21l1-7a.93.93 0 0 1 .07-.2c0-.05.07-.08.1-.07l1.44.18a.69.69 0 0 1 .48.27 1.37 1.37 0 0 1 .25.56 2.93 2.93 0 0 1 .08.75 7.35 7.35 0 0 1-.07.82 3.19 3.19 0 0 1-.11.54 4 4 0 0 1-.12.4c0 .11-.09.19-.13.26l-.09.15a2 2 0 0 1 .15.71 7.05 7.05 0 0 1-.07.94 6.25 6.25 0 0 1-.18.86 3.27 3.27 0 0 1-.29.73 1.32 1.32 0 0 1-.4.49.63.63 0 0 1-.51.14Zm1-1.6.74.1c.09 0 .17-.05.24-.17a1.24 1.24 0 0 0 .15-.46 1.26 1.26 0 0 0 0-.48c0-.14-.1-.21-.19-.22l-.74-.09Zm1.49-3.49a1.17 1.17 0 0 0 0-.46c0-.12-.09-.19-.18-.2l-.7-.09-.18 1.24.7.09c.09 0 .16 0 .23-.14a1.44 1.44 0 0 0 .09-.44Z"
                    style={{
                        fill: "#37474f",
                        transformOrigin: "126.385px 289.743px",
                    }}
                    className="animable"
                />
                <path
                    d="M128.27 293.87s-.05 0-.07-.1a.49.49 0 0 1 0-.21l1-7a.59.59 0 0 1 .06-.2c0-.05.07-.08.1-.07l.59.07a.12.12 0 0 1 .07.1.48.48 0 0 1 0 .21l-1 7a.86.86 0 0 1-.07.21c0 .05-.07.08-.1.07Z"
                    style={{
                        fill: "#37474f",
                        transformOrigin: "129.11px 290.12px",
                    }}
                    className="animable"
                />
                <path
                    d="M132.37 286.64a.83.83 0 0 1 .53.29 1.72 1.72 0 0 1 .35.69 3.94 3.94 0 0 1 .16 1 8.93 8.93 0 0 1-.06 1.24q0 .24-.06.42v.37c0 .12 0 .23-.06.36a3.55 3.55 0 0 1-.06.4 7.41 7.41 0 0 1-.29 1.21 4.66 4.66 0 0 1-.43.92 1.94 1.94 0 0 1-.52.57.81.81 0 0 1-.59.15l-1.22-.15-.07-.1a.7.7 0 0 1 0-.21l1-7a.59.59 0 0 1 .06-.2c0-.05.07-.08.1-.07Zm.15 3.06c.11-.83 0-1.28-.42-1.32l-.46-.06-.6 4.13.48.06c.37.05.63-.34.77-1.18l.06-.42.06-.4.06-.38c.02-.13.03-.27.05-.43Z"
                    style={{
                        fill: "#37474f",
                        transformOrigin: "131.727px 290.398px",
                    }}
                    className="animable"
                />
                <path
                    d="M136 287.1a.79.79 0 0 1 .53.29 1.75 1.75 0 0 1 .35.68 4.1 4.1 0 0 1 .16 1 8.93 8.93 0 0 1-.06 1.24c0 .16 0 .29-.06.42s0 .25 0 .37 0 .23-.05.35 0 .26-.07.41a7.67 7.67 0 0 1-.29 1.21 4.66 4.66 0 0 1-.43.92 1.94 1.94 0 0 1-.52.57.81.81 0 0 1-.59.15l-1.22-.15-.07-.1a.49.49 0 0 1 0-.21l1-7a.59.59 0 0 1 .06-.2s.07-.08.1-.07Zm.15 3.06c.11-.83 0-1.28-.42-1.33l-.46-.05-.6 4.13.48.06c.37 0 .63-.34.77-1.18l.06-.43.02-.36.06-.38c.02-.16.03-.3.05-.46Z"
                    style={{
                        fill: "#37474f",
                        transformOrigin: "135.355px 290.848px",
                    }}
                    className="animable"
                />
                <path
                    d="m139.62 293.55.07.09a.49.49 0 0 1 0 .21l-.16 1.16a.93.93 0 0 1-.07.2.14.14 0 0 1-.1.08l-2.13-.28-.07-.1a.67.67 0 0 1 0-.2l1-7a.52.52 0 0 1 .06-.2c0-.06.07-.08.1-.08l2.09.27s.06 0 .08.1a.74.74 0 0 1 0 .21l-.17 1.15a.52.52 0 0 1-.06.2c0 .06-.07.08-.1.08l-1.38-.18-.17 1.18 1.28.16a.12.12 0 0 1 .07.1.48.48 0 0 1 0 .21l-.17 1.15a.65.65 0 0 1-.06.21c0 .05-.07.08-.1.07l-1.28-.16-.18 1.21Z"
                    style={{
                        fill: "#37474f",
                        transformOrigin: "138.825px 291.36px",
                    }}
                    className="animable"
                />
                <path
                    d="M142.39 295.67s-.08 0-.1-.11a.41.41 0 0 1 0-.16l-.49-3.85-.53 3.67a.77.77 0 0 1-.07.2c0 .06-.07.09-.1.08l-.59-.07s-.05 0-.07-.1a.7.7 0 0 1 0-.21l1-7a.59.59 0 0 1 .06-.2c0-.05.07-.08.1-.07l.47.06s.09 0 .11.11 0 .12 0 .16l.48 3.85.54-3.68a.59.59 0 0 1 .06-.2c0-.05.07-.08.1-.07l.59.07s.06 0 .07.1a.48.48 0 0 1 0 .21l-1 7a.65.65 0 0 1-.06.21s-.07.08-.1.07Z"
                    style={{
                        fill: "#37474f",
                        transformOrigin: "142.232px 291.794px",
                    }}
                    className="animable"
                />
                <path
                    d="M146.72 296.22s-.06 0-.08-.09a.74.74 0 0 1 0-.21l.16-1.11-1.41-.18s-.06 0-.08-.1a.74.74 0 0 1 0-.21l.17-1.15a1.4 1.4 0 0 1 .12-.47l1.94-3.92a.42.42 0 0 1 .1-.15.14.14 0 0 1 .09 0l.68.09s.06 0 .07.1a.48.48 0 0 1 0 .21l-.61 4.17.39.05a.12.12 0 0 1 .07.1.48.48 0 0 1 0 .21l-.17 1.15a.48.48 0 0 1-.07.21c0 .05-.06.08-.09.07h-.39l-.16 1.11a.52.52 0 0 1-.07.2c0 .06-.06.08-.1.08Zm.35-3.15.3-2-1 1.92Z"
                    style={{
                        fill: "#37474f",
                        transformOrigin: "146.897px 292.501px",
                    }}
                    className="animable"
                />
                <path
                    d="M151.09 288.92a.79.79 0 0 1 .54.31 1.88 1.88 0 0 1 .31.7 4.59 4.59 0 0 1 .1 1A11.23 11.23 0 0 1 152 292c0 .32-.09.64-.14 1s-.1.66-.14 1a11.3 11.3 0 0 1-.26 1.11 4.09 4.09 0 0 1-.38.91 1.84 1.84 0 0 1-.49.59.81.81 0 0 1-.61.17.79.79 0 0 1-.55-.31 1.81 1.81 0 0 1-.31-.7 4.59 4.59 0 0 1-.1-1 11.23 11.23 0 0 1 .07-1.13c0-.3.08-.62.13-1s.1-.67.16-1a9 9 0 0 1 .25-1.11 4.09 4.09 0 0 1 .38-.91 1.84 1.84 0 0 1 .49-.59.82.82 0 0 1 .59-.11Zm-.23 4.89c.1-.62.19-1.22.27-1.83v-.5a2.55 2.55 0 0 0 0-.41.71.71 0 0 0-.11-.28.27.27 0 0 0-.21-.13.3.3 0 0 0-.24.07.7.7 0 0 0-.18.25 2.35 2.35 0 0 0-.14.38c0 .15-.07.32-.1.5q-.15.9-.27 1.83a4.77 4.77 0 0 0 0 .5 1.76 1.76 0 0 0 0 .41.66.66 0 0 0 .11.28.27.27 0 0 0 .21.13.3.3 0 0 0 .24-.07.7.7 0 0 0 .18-.25 1.68 1.68 0 0 0 .14-.38c.04-.15.07-.31.1-.5Z"
                    style={{
                        fill: "#37474f",
                        transformOrigin: "150.53px 292.846px",
                    }}
                    className="animable"
                />
                <path
                    d="M155.51 289.6s.06 0 .07.09a.49.49 0 0 1 0 .21l-.17 1.16a.65.65 0 0 1-.06.21l-.09.16-.73 1.25a1.59 1.59 0 0 1 .46.81 3.34 3.34 0 0 1 0 1.39 3.93 3.93 0 0 1-.62 1.81 1.09 1.09 0 0 1-1.06.49.92.92 0 0 1-.55-.26 1.49 1.49 0 0 1-.35-.54 2.71 2.71 0 0 1-.16-.72 3.56 3.56 0 0 1 0-.8.69.69 0 0 1 0-.17s.05-.06.08-.06l.57.07a.17.17 0 0 1 .13.12 2.17 2.17 0 0 0 .07.24.7.7 0 0 0 .13.24.32.32 0 0 0 .26.14.43.43 0 0 0 .38-.13.84.84 0 0 0 .22-.53.86.86 0 0 0-.06-.58.47.47 0 0 0-.33-.22h-.37a.12.12 0 0 1-.07-.1.48.48 0 0 1 0-.21l.14-.94a.65.65 0 0 1 .06-.21l.09-.17.64-1.1-1.17-.15s-.06 0-.07-.1a.48.48 0 0 1 0-.21l.17-1.15a.4.4 0 0 1 .07-.2c0-.06.06-.08.09-.08Z"
                    style={{
                        fill: "#37474f",
                        transformOrigin: "153.909px 293.275px",
                    }}
                    className="animable"
                />
                <path
                    d="M160.1 290.18s.06 0 .08.1a.74.74 0 0 1 0 .21l-.17 1.15a.58.58 0 0 1-.06.21s-.07.08-.1.07l-1.34-.17-.22 1.49 1.25.16s.06 0 .08.1a.74.74 0 0 1 0 .21l-.17 1.15a.65.65 0 0 1-.06.21c0 .05-.07.08-.1.07L158 295l-.34 2.35a.52.52 0 0 1-.07.2c0 .06-.06.08-.1.08l-.59-.08s-.05 0-.07-.09a.54.54 0 0 1 0-.22l1-7a.52.52 0 0 1 .06-.2c0-.06.07-.08.1-.08Z"
                    style={{
                        fill: "#37474f",
                        transformOrigin: "158.503px 293.795px",
                    }}
                    className="animable"
                />
                <path
                    d="M160.47 293.12a8.91 8.91 0 0 1 .27-1.13 4.74 4.74 0 0 1 .41-.9 2.15 2.15 0 0 1 .53-.58.91.91 0 0 1 .62-.16.86.86 0 0 1 .55.31 2 2 0 0 1 .34.69 3.93 3.93 0 0 1 .13 1 6.63 6.63 0 0 1 0 1.16c0 .31-.09.64-.14 1s-.1.66-.14 1a8.64 8.64 0 0 1-.28 1.14 4.19 4.19 0 0 1-.41.9 1.88 1.88 0 0 1-.53.58.84.84 0 0 1-.61.15.89.89 0 0 1-.56-.3 1.93 1.93 0 0 1-.33-.69 3.9 3.9 0 0 1-.14-1 7.71 7.71 0 0 1 .06-1.16c0-.3.08-.62.13-1s.05-.7.1-1.01Zm1.69 2.13c0-.13.05-.27.08-.43s0-.32.07-.49.05-.33.07-.48 0-.3.05-.42a4.77 4.77 0 0 0 0-.51 2.42 2.42 0 0 0-.05-.41.78.78 0 0 0-.14-.29.34.34 0 0 0-.23-.13.32.32 0 0 0-.25.07.83.83 0 0 0-.21.24 1.76 1.76 0 0 0-.17.39 3.19 3.19 0 0 0-.12.49c0 .12 0 .26-.07.42s-.05.31-.08.48l-.06.49c0 .16 0 .31-.06.44a2.73 2.73 0 0 0 0 .92c0 .25.17.39.36.41s.34-.08.47-.3a3 3 0 0 0 .34-.89Z"
                    style={{
                        fill: "#37474f",
                        transformOrigin: "161.762px 294.317px",
                    }}
                    className="animable"
                />
                <path
                    d="M165.89 290.92a1 1 0 0 1 .51.22 1.19 1.19 0 0 1 .33.51 2.64 2.64 0 0 1 .13.81 5.59 5.59 0 0 1-.07 1.11 6 6 0 0 1-.33 1.34 2 2 0 0 1-.52.77l.18 2.66a.48.48 0 0 1 0 .12.43.43 0 0 1-.06.17.1.1 0 0 1-.07.06l-.62-.08a.14.14 0 0 1-.11-.11.76.76 0 0 1 0-.21l-.16-2.39h-.41l-.34 2.33a.59.59 0 0 1-.07.2c0 .05-.06.08-.1.07l-.58-.07s-.06 0-.08-.1a.74.74 0 0 1 0-.21l1-7a.48.48 0 0 1 .07-.21s.06-.08.09-.07Zm-1 3.23.51.07a.39.39 0 0 0 .34-.14 1.12 1.12 0 0 0 .21-.61 1.08 1.08 0 0 0 0-.65.35.35 0 0 0-.29-.21l-.5-.07Z"
                    style={{
                        fill: "#37474f",
                        transformOrigin: "165.188px 294.765px",
                    }}
                    className="animable"
                />
                <path
                    d="M167 298.82s-.06 0-.07-.1a.48.48 0 0 1 0-.21l1-7a.65.65 0 0 1 .07-.21s.06-.08.1-.07l1.44.18a.73.73 0 0 1 .48.27 1.37 1.37 0 0 1 .25.56 3 3 0 0 1 .07.75 5.55 5.55 0 0 1-.06.82 5.33 5.33 0 0 1-.11.55 2.54 2.54 0 0 1-.13.39 1.29 1.29 0 0 1-.12.26l-.09.15a1.8 1.8 0 0 1 .14.71 5.5 5.5 0 0 1-.06.94c-.05.3-.11.58-.18.86a3.83 3.83 0 0 1-.29.73 1.47 1.47 0 0 1-.4.5.67.67 0 0 1-.51.14Zm.95-1.6.74.1c.09 0 .17 0 .25-.16a1.37 1.37 0 0 0 .15-.47 1.25 1.25 0 0 0 0-.48c0-.13-.09-.21-.18-.22l-.74-.09Zm1.5-3.49a1.4 1.4 0 0 0 0-.46c0-.12-.09-.19-.18-.2l-.7-.09-.18 1.24.7.09a.22.22 0 0 0 .22-.14 1.14 1.14 0 0 0 .16-.44Z"
                    style={{
                        fill: "#37474f",
                        transformOrigin: "168.63px 295.138px",
                    }}
                    className="animable"
                />
                <path
                    d="M170.55 299.27s-.06 0-.07-.1a.48.48 0 0 1 0-.21l1-7a.52.52 0 0 1 .07-.2c0-.06.06-.08.1-.08l.58.08s.06 0 .08.09a.74.74 0 0 1 0 .21l-1 7a.4.4 0 0 1-.07.2c0 .06-.06.08-.09.08Z"
                    style={{
                        fill: "#37474f",
                        transformOrigin: "171.393px 295.51px",
                    }}
                    className="animable"
                />
                <path
                    d="M174.66 292a.82.82 0 0 1 .53.3 1.75 1.75 0 0 1 .35.68 4.1 4.1 0 0 1 .16 1 9 9 0 0 1-.06 1.24q0 .23-.06.42c0 .13 0 .25-.05.36s0 .24-.05.36 0 .26-.07.4a7.54 7.54 0 0 1-.29 1.22 4.94 4.94 0 0 1-.43.92 1.94 1.94 0 0 1-.52.57.86.86 0 0 1-.59.15l-1.22-.16s-.05 0-.07-.09a.5.5 0 0 1 0-.21l1-7a.52.52 0 0 1 .06-.2c0-.06.07-.08.1-.08Zm.15 3.07c.11-.84 0-1.28-.42-1.33l-.46-.06-.6 4.13.48.07c.37 0 .63-.35.77-1.18l.06-.43.06-.39.06-.39c.02-.09.03-.23.05-.38Z"
                    style={{
                        fill: "#37474f",
                        transformOrigin: "173.99px 295.753px",
                    }}
                    className="animable"
                />
                <path
                    d="M178.25 292.5a.87.87 0 0 1 .53.3 1.75 1.75 0 0 1 .35.68 3.63 3.63 0 0 1 .15 1 6.71 6.71 0 0 1-.06 1.24c0 .15 0 .29-.05.42s0 .25 0 .36l-.06.36c0 .12 0 .26-.06.4a6.81 6.81 0 0 1-.3 1.22 4.38 4.38 0 0 1-.42.92 1.94 1.94 0 0 1-.52.57.93.93 0 0 1-.6.15L176 300s-.06 0-.07-.1a.48.48 0 0 1 0-.21l1-7a.77.77 0 0 1 .07-.2c0-.06.07-.08.1-.08Zm.15 3.07c.1-.84 0-1.28-.43-1.33l-.46-.06-.6 4.13.48.06c.38.05.64-.34.77-1.17 0-.15.05-.3.07-.43l.06-.39c0-.13 0-.26.05-.39s.04-.27.06-.42Z"
                    style={{
                        fill: "#37474f",
                        transformOrigin: "177.602px 296.267px",
                    }}
                    className="animable"
                />
                <path
                    d="M181.91 299s.05 0 .07.1a.49.49 0 0 1 0 .21l-.16 1.15a.77.77 0 0 1-.07.2c0 .06-.07.09-.1.08l-2.12-.27s-.06 0-.08-.1a.74.74 0 0 1 0-.21l1-7a.48.48 0 0 1 .07-.21c0-.05.06-.08.09-.07l2.09.27s.06 0 .08.09a.8.8 0 0 1 0 .22l-.17 1.15a.59.59 0 0 1-.06.2.14.14 0 0 1-.1.08l-1.38-.18-.17 1.17 1.28.17s.06 0 .07.1a.48.48 0 0 1 0 .21l-.17 1.15a.52.52 0 0 1-.06.2c0 .06-.07.08-.1.08l-1.29-.17-.17 1.22Z"
                    style={{
                        fill: "#37474f",
                        transformOrigin: "181.115px 296.81px",
                    }}
                    className="animable"
                />
                <path
                    d="M184.67 301.08a.15.15 0 0 1-.11-.12.73.73 0 0 1 0-.16L184 297l-.53 3.68a.4.4 0 0 1-.07.2c0 .06-.06.08-.09.08l-.59-.08s-.06 0-.07-.1a.48.48 0 0 1 0-.21l1-7a.52.52 0 0 1 .07-.2c0-.06.06-.08.1-.08l.46.06a.14.14 0 0 1 .11.11.9.9 0 0 1 0 .16l.49 3.85.53-3.67a.4.4 0 0 1 .07-.2c0-.06.06-.08.09-.08l.59.07s.06 0 .08.1a.74.74 0 0 1 0 .21l-1 7a.4.4 0 0 1-.07.2c0 .06-.06.08-.09.08Z"
                    style={{
                        fill: "#37474f",
                        transformOrigin: "184.443px 297.235px",
                    }}
                    className="animable"
                />
                <path
                    d="M189 301.63a.12.12 0 0 1-.07-.1.48.48 0 0 1 0-.21l.16-1.11-1.41-.18s-.06 0-.07-.1a.48.48 0 0 1 0-.21l.17-1.15a1.61 1.61 0 0 1 .12-.46l1.94-3.93a.42.42 0 0 1 .1-.15.11.11 0 0 1 .1 0l.67.08s.06 0 .08.1a.74.74 0 0 1 0 .21l-.6 4.18.38.05s.06 0 .07.09a.53.53 0 0 1 0 .22l-.17 1.15a.52.52 0 0 1-.06.2s-.07.08-.1.08l-.39-.05-.16 1.11a.43.43 0 0 1-.07.2c0 .05-.06.08-.09.07Zm.36-3.16.29-2-.95 1.92Z"
                    style={{
                        fill: "#37474f",
                        transformOrigin: "189.198px 297.87px",
                    }}
                    className="animable"
                />
                <path
                    d="M193.37 294.33a.76.76 0 0 1 .54.31 1.83 1.83 0 0 1 .31.69 4.07 4.07 0 0 1 .1 1 8.94 8.94 0 0 1-.07 1.14c0 .31-.08.64-.13 1s-.1.66-.15.95a8.77 8.77 0 0 1-.26 1.12 4.53 4.53 0 0 1-.37.91 2 2 0 0 1-.5.59.79.79 0 0 1-.61.16.76.76 0 0 1-.55-.31 1.83 1.83 0 0 1-.3-.69 4.63 4.63 0 0 1-.11-1 9 9 0 0 1 .08-1.14c0-.3.08-.62.13-1s.1-.66.15-1a9 9 0 0 1 .25-1.11 4.53 4.53 0 0 1 .38-.91 2 2 0 0 1 .49-.59.82.82 0 0 1 .62-.12Zm-.23 4.88c.11-.61.19-1.22.27-1.82v-.51a1.67 1.67 0 0 0 0-.4.7.7 0 0 0-.11-.29.28.28 0 0 0-.21-.12.26.26 0 0 0-.23.06.86.86 0 0 0-.19.25 2.49 2.49 0 0 0-.14.39 4.9 4.9 0 0 0-.1.5c-.1.59-.19 1.2-.27 1.82v.5a1.73 1.73 0 0 0 0 .41.7.7 0 0 0 .11.29.28.28 0 0 0 .21.12.29.29 0 0 0 .24-.06.7.7 0 0 0 .18-.25 1.77 1.77 0 0 0 .14-.39 3.15 3.15 0 0 0 .1-.5Z"
                    style={{
                        fill: "#37474f",
                        transformOrigin: "192.796px 298.261px",
                    }}
                    className="animable"
                />
                <path
                    d="M197.78 295s.05 0 .07.1a.7.7 0 0 1 0 .21l-.17 1.15a.65.65 0 0 1-.07.21.79.79 0 0 1-.08.16l-.73 1.26a1.52 1.52 0 0 1 .46.8 3.57 3.57 0 0 1 0 1.4 3.84 3.84 0 0 1-.62 1.8 1.13 1.13 0 0 1-1.07.5 1 1 0 0 1-.54-.26 1.48 1.48 0 0 1-.35-.55 2.54 2.54 0 0 1-.16-.72 3.07 3.07 0 0 1 0-.8.42.42 0 0 1 .05-.17s0-.06.08-.06l.57.08q.09 0 .12.12c0 .07.05.15.08.23a.85.85 0 0 0 .13.25.34.34 0 0 0 .26.13.45.45 0 0 0 .38-.12.94.94 0 0 0 .22-.54.84.84 0 0 0-.06-.57.44.44 0 0 0-.33-.22l-.37-.05s-.06 0-.08-.1a.74.74 0 0 1 0-.21l.13-.93a.81.81 0 0 1 .07-.22l.09-.16.64-1.11-1.17-.14a.12.12 0 0 1-.07-.1.48.48 0 0 1 0-.21l.17-1.16a.59.59 0 0 1 .06-.2c0-.05.07-.08.1-.07Z"
                    style={{
                        fill: "#37474f",
                        transformOrigin: "196.176px 298.663px",
                    }}
                    className="animable"
                />
                <path
                    d="M202.36 295.59s.06 0 .08.09a.81.81 0 0 1 0 .22l-.17 1.15a.59.59 0 0 1-.06.2c0 .05-.07.08-.1.08l-1.34-.18-.22 1.49 1.25.16s.06 0 .08.1a.74.74 0 0 1 0 .21l-.17 1.16a.59.59 0 0 1-.06.2s-.07.08-.1.07l-1.25-.16-.34 2.35a.77.77 0 0 1-.07.2c0 .06-.06.08-.1.08l-.59-.08-.07-.09a.49.49 0 0 1 0-.21l1-7a.59.59 0 0 1 .06-.2c0-.06.07-.08.1-.08Z"
                    style={{
                        fill: "#37474f",
                        transformOrigin: "200.783px 299.18px",
                    }}
                    className="animable"
                />
                <path
                    d="M202.76 298.53a7.18 7.18 0 0 1 .28-1.13 3.78 3.78 0 0 1 .41-.9 2 2 0 0 1 .52-.58.87.87 0 0 1 .62-.16.84.84 0 0 1 .55.31 1.89 1.89 0 0 1 .34.68 4.06 4.06 0 0 1 .14 1 7.85 7.85 0 0 1-.06 1.16c0 .31-.08.63-.13 1s-.1.66-.15.95A7.6 7.6 0 0 1 205 302a3.94 3.94 0 0 1-.41.9 1.85 1.85 0 0 1-.52.58.88.88 0 0 1-1.17-.15 1.86 1.86 0 0 1-.34-.69 4.52 4.52 0 0 1-.14-1 7.91 7.91 0 0 1 .06-1.17c0-.29.08-.61.13-.95s.1-.68.15-.99Zm1.7 2.13c0-.13 0-.27.07-.43s.05-.32.08-.49l.06-.49c0-.15 0-.29.05-.42a3 3 0 0 0 0-.5 1.64 1.64 0 0 0-.05-.41.71.71 0 0 0-.13-.29.32.32 0 0 0-.23-.13.36.36 0 0 0-.26.07.63.63 0 0 0-.21.24 2.7 2.7 0 0 0-.17.38c0 .15-.08.32-.11.5s-.05.26-.08.42 0 .31-.07.48-.05.33-.07.49 0 .3-.05.44a3 3 0 0 0 0 .92c.06.25.18.39.37.41a.47.47 0 0 0 .46-.31 2.83 2.83 0 0 0 .34-.88Z"
                    style={{
                        fill: "#37474f",
                        transformOrigin: "204.02px 299.695px",
                    }}
                    className="animable"
                />
                <path
                    d="M208.17 296.33a.91.91 0 0 1 .5.22 1.13 1.13 0 0 1 .33.5 2.62 2.62 0 0 1 .14.81 6.52 6.52 0 0 1-.07 1.12 5.54 5.54 0 0 1-.34 1.34 2 2 0 0 1-.51.77l.18 2.65v.12a.43.43 0 0 1-.06.17c0 .05-.05.06-.08.06l-.61-.08c-.06 0-.1 0-.11-.11a.75.75 0 0 1 0-.2l-.16-2.39-.42-.06-.34 2.33a.52.52 0 0 1-.06.2c0 .06-.07.08-.1.08l-.59-.08s-.05 0-.07-.09a.79.79 0 0 1 0-.22l1-7a.52.52 0 0 1 .06-.2c0-.06.07-.08.1-.08Zm-1 3.23.51.06a.37.37 0 0 0 .33-.13 1.68 1.68 0 0 0 .19-1.26.38.38 0 0 0-.29-.22l-.51-.06Z"
                    style={{
                        fill: "#37474f",
                        transformOrigin: "207.467px 300.14px",
                    }}
                    className="animable"
                />
                <path
                    d="M209.29 304.22s-.06 0-.07-.09a.48.48 0 0 1 0-.21l1-7a.77.77 0 0 1 .07-.2c0-.06.06-.08.1-.08l1.44.19a.68.68 0 0 1 .48.26 1.41 1.41 0 0 1 .25.57 2.52 2.52 0 0 1 .07.75 5.55 5.55 0 0 1-.06.82 4.63 4.63 0 0 1-.11.54 2.35 2.35 0 0 1-.13.4 2.17 2.17 0 0 1-.12.26l-.09.14a1.85 1.85 0 0 1 .14.72 5.39 5.39 0 0 1-.06.93 6.09 6.09 0 0 1-.18.87 3.27 3.27 0 0 1-.29.73 1.53 1.53 0 0 1-.4.49.67.67 0 0 1-.51.14Zm1-1.59.75.09c.08 0 .16 0 .24-.16a1.31 1.31 0 0 0 .15-.46 1.5 1.5 0 0 0 0-.48c0-.14-.1-.21-.19-.22l-.74-.1Zm1.5-3.5a1.17 1.17 0 0 0 0-.46c0-.12-.09-.18-.18-.19l-.7-.09-.18 1.24.7.09c.09 0 .16 0 .23-.14a1.43 1.43 0 0 0 .08-.45Z"
                    style={{
                        fill: "#37474f",
                        transformOrigin: "210.921px 300.548px",
                    }}
                    className="animable"
                />
                <path
                    d="M212.83 304.68s-.06 0-.08-.1a.74.74 0 0 1 0-.21l1-7a.43.43 0 0 1 .07-.2c0-.05.06-.08.09-.07l.59.07s.06 0 .07.1a.48.48 0 0 1 0 .21l-1 7a.52.52 0 0 1-.07.2c0 .06-.06.09-.1.08Z"
                    style={{
                        fill: "#37474f",
                        transformOrigin: "213.662px 300.93px",
                    }}
                    className="animable"
                />
                <path
                    d="M216.92 297.45a.81.81 0 0 1 .53.29 1.89 1.89 0 0 1 .35.68 4.13 4.13 0 0 1 .15 1 6.68 6.68 0 0 1-.06 1.24v.42l-.06.37c0 .11 0 .23-.05.35s0 .26-.06.41a7.64 7.64 0 0 1-.3 1.21 4.15 4.15 0 0 1-.42.92 2 2 0 0 1-.53.57.8.8 0 0 1-.59.15l-1.21-.15a.12.12 0 0 1-.07-.1.48.48 0 0 1 0-.21l1-7a.59.59 0 0 1 .07-.2c0-.05.06-.08.1-.07Zm.15 3.06c.1-.83 0-1.28-.43-1.33l-.46-.06-.6 4.14.48.06c.38.05.64-.35.77-1.18 0-.15 0-.29.07-.43l.06-.39v-.38c0-.13.09-.28.11-.43Z"
                    style={{
                        fill: "#37474f",
                        transformOrigin: "216.273px 301.198px",
                    }}
                    className="animable"
                />
                <path
                    d="M220.51 297.91a.81.81 0 0 1 .54.29 2.06 2.06 0 0 1 .35.68 4.69 4.69 0 0 1 .15 1 6.68 6.68 0 0 1-.06 1.24l-.06.42c0 .13 0 .25-.05.36s0 .24 0 .36l-.06.4a8.71 8.71 0 0 1-.3 1.22 4.15 4.15 0 0 1-.42.92 2 2 0 0 1-.53.57.81.81 0 0 1-.59.15l-1.21-.16s-.06 0-.08-.09a.74.74 0 0 1 0-.21l1-7a.4.4 0 0 1 .07-.2c0-.06.06-.08.1-.08Zm.16 3.06c.1-.83 0-1.28-.43-1.33l-.46-.06-.6 4.14.48.06c.38 0 .63-.35.77-1.18 0-.15 0-.29.07-.43s0-.26.05-.39l.06-.38c.02-.13.04-.28.06-.4Z"
                    style={{
                        fill: "#37474f",
                        transformOrigin: "219.87px 301.654px",
                    }}
                    className="animable"
                />
                <path
                    d="m224.18 304.36.07.09a.49.49 0 0 1 0 .21l-.16 1.16a.93.93 0 0 1-.07.2c0 .05-.06.08-.1.07l-2.13-.27-.07-.09a.74.74 0 0 1 0-.21l1-7a.4.4 0 0 1 .07-.2c0-.06.06-.08.09-.08l2.09.27s.06 0 .08.1a.74.74 0 0 1 0 .21l-.17 1.15a.52.52 0 0 1-.06.2c0 .06-.07.08-.1.08l-1.38-.18-.17 1.18 1.28.16a.12.12 0 0 1 .07.1.48.48 0 0 1 0 .21l-.17 1.15a.52.52 0 0 1-.06.2c0 .06-.07.08-.1.08l-1.29-.16-.17 1.21Z"
                    style={{
                        fill: "#37474f",
                        transformOrigin: "223.385px 302.166px",
                    }}
                    className="animable"
                />
                <path
                    d="M226.94 306.48c-.05 0-.08 0-.11-.11a.69.69 0 0 1 0-.16l-.49-3.85-.54 3.67a.52.52 0 0 1-.06.2c0 .06-.07.08-.1.08l-.59-.08s-.06 0-.07-.09a.48.48 0 0 1 0-.21l1-7a.52.52 0 0 1 .06-.2c0-.06.07-.08.1-.08l.47.06c.05 0 .08.05.1.12a.41.41 0 0 1 0 .16l.49 3.85.53-3.68a.77.77 0 0 1 .07-.2.14.14 0 0 1 .1-.08l.59.08.07.1a.48.48 0 0 1 0 .21l-1 7a.52.52 0 0 1-.06.2c0 .06-.07.08-.1.08Z"
                    style={{
                        fill: "#37474f",
                        transformOrigin: "226.77px 302.6px",
                    }}
                    className="animable"
                />
            </g>
        </g>
        <g
            className="animable"
            style={{
                transformOrigin: "163.023px 80.2952px",
            }}
        >
            <g
                className="animable"
                style={{
                    transformOrigin: "163.023px 80.2952px",
                }}
            >
                <path
                    d="M142.21 105.27a1.09 1.09 0 0 0-.17-.13l-5.26-3V77.19a1.71 1.71 0 0 0-.41-1.27.64.64 0 0 0-.17-.13l-5.62-3.24a.75.75 0 0 0-.82 0L122 77.11a3.55 3.55 0 0 0-1.07.89 7.56 7.56 0 0 0-.85 1.65l-15.52 38.95a10.66 10.66 0 0 0-.67 3.81v8.45a1.67 1.67 0 0 0 .42 1.27.7.7 0 0 0 .17.13l5.62 3.25a.75.75 0 0 0 .81-.06l10.67-6.16v1.63a1.69 1.69 0 0 0 .42 1.27l.16.13 5.63 3.25a.79.79 0 0 0 .82-.06l6.77-3.91a2.64 2.64 0 0 0 1-1.21 4.14 4.14 0 0 0 .41-1.75v-8.12l4.45-2.57a2.63 2.63 0 0 0 1-1.21 4 4 0 0 0 .41-1.75v-8.44a1.7 1.7 0 0 0-.44-1.28Z"
                    style={{
                        fill: "#975ac2",
                        transformOrigin: "123.269px 104.043px",
                    }}
                    className="animable"
                />
                <path
                    d="M126.47 81.24v.1a7.51 7.51 0 0 0-.79 1.55l-15.47 39a9.49 9.49 0 0 0-.46 1.6l-5.66-3.27a10.25 10.25 0 0 1 .45-1.58L120 79.65a7.74 7.74 0 0 1 .86-1.65Z"
                    style={{
                        opacity: 0.15,
                        transformOrigin: "115.28px 100.745px",
                    }}
                    className="animable"
                />
                <path
                    d="M110 135.47c-.63-.37-5.32-3.08-5.55-3.2l-.17-.14a1.7 1.7 0 0 1-.42-1.28v-8.43a11.37 11.37 0 0 1 .22-2.22l5.62 3.25a11.3 11.3 0 0 0-.21 2.22v8.44a1.73 1.73 0 0 0 .41 1.27Z"
                    style={{
                        opacity: 0.3,
                        transformOrigin: "106.927px 127.835px",
                    }}
                    className="animable"
                />
                <path
                    style={{
                        opacity: 0.3,
                        transformOrigin: "125.1px 105.825px",
                    }}
                    className="animable"
                    d="M127.47 98.5v14.65l-4.74-2.73 4.74-11.92z"
                />
                <path
                    style={{
                        opacity: 0.4,
                        transformOrigin: "123.695px 113.965px",
                    }}
                    className="animable"
                    d="m127.47 113.15-7.55 4.36 2.81-7.09 4.74 2.73z"
                />
                <path
                    d="m127.62 135.44.1.08-5.55-3.2a.43.43 0 0 1-.17-.13 1.67 1.67 0 0 1-.42-1.27v-1.63l5.63-3.25v8.12a1.74 1.74 0 0 0 .41 1.28Z"
                    style={{
                        opacity: 0.3,
                        transformOrigin: "124.646px 130.78px",
                    }}
                    className="animable"
                />
                <path
                    d="M142 105.11a.78.78 0 0 0-.74.09l-4.45 2.57v-5.66Z"
                    style={{
                        opacity: 0.15,
                        transformOrigin: "139.405px 104.94px",
                    }}
                    className="animable"
                />
                <path
                    d="M136.16 75.77a.79.79 0 0 0-.78.07l-7.81 4.51a3.76 3.76 0 0 0-1 .89L120.89 78a3.72 3.72 0 0 1 1-.88l7.82-4.51a.75.75 0 0 1 .82 0Z"
                    style={{
                        fill: "#fff",
                        opacity: 0.4,
                        transformOrigin: "128.525px 76.864px",
                    }}
                    className="animable"
                />
                <path
                    d="M128.61 135.51a.77.77 0 0 1-1-.07 1.74 1.74 0 0 1-.41-1.28V126l-16.3 9.41a.74.74 0 0 1-1-.07 1.74 1.74 0 0 1-.41-1.28v-8.44a10.45 10.45 0 0 1 .67-3.81l15.47-39a7.24 7.24 0 0 1 .85-1.64 3.51 3.51 0 0 1 1.06-.89l7.81-4.51a.75.75 0 0 1 1 .07 1.71 1.71 0 0 1 .41 1.27v30.58l4.45-2.57a.76.76 0 0 1 1 .07 1.7 1.7 0 0 1 .41 1.28V115a4 4 0 0 1-.41 1.75 2.63 2.63 0 0 1-1 1.21l-4.45 2.57v8.12a4.14 4.14 0 0 1-.41 1.75 2.64 2.64 0 0 1-1 1.21Zm-1.14-22.36V98.5l-7.55 19Z"
                    style={{
                        fill: "#975ac2",
                        transformOrigin: "126.056px 105.637px",
                    }}
                    className="animable"
                />
                <path
                    d="M181.49 70a34.85 34.85 0 0 0-1.06-7.63 11.8 11.8 0 0 0-2.74-5.31 6.76 6.76 0 0 0-1.41-1.06l-5.64-3.25a6.94 6.94 0 0 0-3.21-.91 12.68 12.68 0 0 0-6.67 2.1 24.42 24.42 0 0 0-6.67 5.6 32.84 32.84 0 0 0-4.63 7.38 38.69 38.69 0 0 0-2.75 8.47 55.19 55.19 0 0 0-1.06 8.85q-.1 3.5-.1 7.23c0 2.5 0 4.81.1 7a35.47 35.47 0 0 0 1.06 7.63 11.81 11.81 0 0 0 2.75 5.31 6.12 6.12 0 0 0 1.4 1.1c.94.56 5.18 3 5.72 3.31a7.11 7.11 0 0 0 3.13.86 12.68 12.68 0 0 0 6.67-2.1 24.46 24.46 0 0 0 6.68-5.6 33.57 33.57 0 0 0 4.63-7.38 38.67 38.67 0 0 0 2.74-8.47 54.08 54.08 0 0 0 1.06-8.85q.1-3.33.1-7.07t-.1-7.21Zm-20.44 28.3a22.2 22.2 0 0 1-.2-2.6q-.25-6.63 0-13.38a26.75 26.75 0 0 1 .36-3.88 17.86 17.86 0 0 1 .93-3.44 11.62 11.62 0 0 1 1.66-2.91 8.47 8.47 0 0 1 2.25-2q.16 1.17.24 2.58.21 6.48 0 13.38a29.35 29.35 0 0 1-.33 3.85 15.61 15.61 0 0 1-.93 3.45 11.91 11.91 0 0 1-1.69 2.92 8.75 8.75 0 0 1-2.29 2.05Z"
                    style={{
                        fill: "#975ac2",
                        transformOrigin: "163.57px 84.26px",
                    }}
                    className="animable"
                />
                <path
                    d="M156.43 115.65c-.93-.53-4.7-2.7-5.57-3.22a6.65 6.65 0 0 1-1.4-1.1 11.81 11.81 0 0 1-2.75-5.31 35.47 35.47 0 0 1-1.06-7.63c-.06-2.14-.1-4.45-.1-7s0-4.91.1-7.23a55.06 55.06 0 0 1 1.06-8.85 38.81 38.81 0 0 1 1.75-6.06l5.62 3.25a39 39 0 0 0-1.74 6 53.12 53.12 0 0 0-1.06 8.86q-.1 3.48-.11 7.23c0 2.5 0 4.81.11 7a34.34 34.34 0 0 0 1.06 7.63 11.71 11.71 0 0 0 2.74 5.3 6.54 6.54 0 0 0 1.35 1.13Z"
                    style={{
                        opacity: 0.15,
                        transformOrigin: "150.99px 92.45px",
                    }}
                    className="animable"
                />
                <path
                    d="M176.06 55.85a7.13 7.13 0 0 0-3-.79q-2.79-.14-6.68 2.1a24.57 24.57 0 0 0-6.67 5.61 33.21 33.21 0 0 0-4.63 7.36c-.19.41-.36.81-.53 1.23l-.47 1.19-5.62-3.25c.13-.36.27-.71.41-1.06s.38-.9.59-1.35a33.3 33.3 0 0 1 4.62-7.38 24.76 24.76 0 0 1 6.68-5.6 12.59 12.59 0 0 1 6.67-2.1 6.9 6.9 0 0 1 3.21.91Z"
                    style={{
                        fill: "#fff",
                        opacity: 0.4,
                        transformOrigin: "162.26px 62.18px",
                    }}
                    className="animable"
                />
                <path
                    d="M171.92 89.32a29.32 29.32 0 0 1-.34 3.86 15.52 15.52 0 0 1-.92 3.44A12 12 0 0 1 170 98l-5.62-3.25a12.61 12.61 0 0 0 .63-1.34 15.77 15.77 0 0 0 .94-3.45 29.35 29.35 0 0 0 .33-3.85q.21-6.89 0-13.38c0-.94-.13-1.8-.24-2.59l.33-.21a4.35 4.35 0 0 1 2.59-.78 2.34 2.34 0 0 1 1.66 1 6.11 6.11 0 0 1 .9 2.38 26.61 26.61 0 0 1 .39 3.45q.21 6.45.01 13.34Z"
                    style={{
                        opacity: 0.3,
                        transformOrigin: "168.199px 83.5744px",
                    }}
                    className="animable"
                />
                <path
                    d="M170 98a10.51 10.51 0 0 1-1 1.58 8.86 8.86 0 0 1-2.59 2.21 4.38 4.38 0 0 1-2.58.77 2.33 2.33 0 0 1-1.68-1 5.76 5.76 0 0 1-.93-2.37c-.06-.28-.1-.57-.14-.87a8.6 8.6 0 0 0 2.29-2 11.4 11.4 0 0 0 1-1.58Z"
                    style={{
                        opacity: 0.4,
                        transformOrigin: "165.54px 98.6505px",
                    }}
                    className="animable"
                />
                <path
                    d="M166.38 57.16q3.88-2.25 6.68-2.1a6.71 6.71 0 0 1 4.63 2 11.8 11.8 0 0 1 2.74 5.31 34.85 34.85 0 0 1 1.06 7.63q.1 3.36.1 7.11t-.1 7.07a54.08 54.08 0 0 1-1.06 8.85 38.67 38.67 0 0 1-2.74 8.47 33.57 33.57 0 0 1-4.63 7.38 24.46 24.46 0 0 1-6.68 5.6 12.68 12.68 0 0 1-6.67 2.1 6.68 6.68 0 0 1-4.63-2 11.71 11.71 0 0 1-2.74-5.3 34.94 34.94 0 0 1-1.06-7.63c-.07-2.14-.1-4.45-.1-7s0-4.9.1-7.23a54 54 0 0 1 1.06-8.85 38.93 38.93 0 0 1 2.74-8.48 33.5 33.5 0 0 1 4.63-7.37 24.57 24.57 0 0 1 6.67-5.56Zm5.54 32.16q.21-6.88 0-13.38a26.64 26.64 0 0 0-.39-3.44 6.17 6.17 0 0 0-.9-2.38 2.31 2.31 0 0 0-1.66-1 4.44 4.44 0 0 0-2.59.78 9 9 0 0 0-2.58 2.21 11.62 11.62 0 0 0-1.66 2.89 17.86 17.86 0 0 0-.93 3.44 26.75 26.75 0 0 0-.36 3.88q-.25 6.75 0 13.38a21.32 21.32 0 0 0 .34 3.46 5.52 5.52 0 0 0 .93 2.37 2.31 2.31 0 0 0 1.68 1 4.38 4.38 0 0 0 2.58-.77 9 9 0 0 0 2.62-2.21 11.88 11.88 0 0 0 1.68-2.92 15.76 15.76 0 0 0 .93-3.45 31.14 31.14 0 0 0 .31-3.86Z"
                    style={{
                        fill: "#975ac2",
                        transformOrigin: "166.385px 85.8153px",
                    }}
                    className="animable"
                />
                <path
                    d="M219.68 56a6.27 6.27 0 0 0-1.16-.85 6.56 6.56 0 0 0-.76-.35 6 6 0 0 1 .58.25l-4.27-2.48 5.3-11.28c.21-.44.43-1 .66-1.57a4.82 4.82 0 0 0 .36-1.77v-8.36a1.68 1.68 0 0 0-.41-1.26.91.91 0 0 0-.24-.16L214.25 25a.81.81 0 0 0-.79.07L189 39.14a2.31 2.31 0 0 0-.83 1 1.49 1.49 0 0 0-.14.24 4.17 4.17 0 0 0-.41 1.74v8.28a1.66 1.66 0 0 0 .41 1.25 1.46 1.46 0 0 0 .21.16c.19.09 4.54 2.62 5.41 3.12 0 0-.05 0-.06-.06a.75.75 0 0 0 1 .07l3.61-2.09-1.2 2.72a17.85 17.85 0 0 0-.71 1.67 3.17 3.17 0 0 0-.14.4c0 .13-.08.26-.11.4a.11.11 0 0 1 0 .05 1.9 1.9 0 0 0 0 .25v.08a3.1 3.1 0 0 0-.05.6v6.76a1.73 1.73 0 0 0 .4 1.26 1.43 1.43 0 0 0 .22.15l5.39 3.15-.08-.06a.75.75 0 0 0 .94 0l4.23-2.45a7.94 7.94 0 0 1-1.52 3.72 12.92 12.92 0 0 1-4.06 3.6 5.83 5.83 0 0 1-3.13 1.07 5.76 5.76 0 0 1-.66-.1l-2.44-1.41a1 1 0 0 0-.34-.11 2 2 0 0 0-1.23.36l-6.44 3.72a2.18 2.18 0 0 0-.79 1 .49.49 0 0 0 0 .11 4.15 4.15 0 0 0-.22.65 2.88 2.88 0 0 0-.07.65 12.08 12.08 0 0 0 1.09 5.06 7.11 7.11 0 0 0 3 3.28c.82.46 4.08 2.38 5.34 3.09-.18-.11-.34-.24-.5-.36a6 6 0 0 0 .72.48 7.9 7.9 0 0 0 4.77.78 17.12 17.12 0 0 0 6.45-2.42 29.39 29.39 0 0 0 15.12-26.58c0-4.1-.83-6.9-2.5-8.42Z"
                    style={{
                        fill: "#975ac2",
                        transformOrigin: "204.192px 59.2179px",
                    }}
                    className="animable"
                />
                <path
                    d="M188.18 40.22a.64.64 0 0 0 0-.07l-.13.25a4 4 0 0 0-.41 1.74v8.32a1.63 1.63 0 0 0 .41 1.26.7.7 0 0 0 .2.15l5.43 3.13a.12.12 0 0 0-.06-.06 1.65 1.65 0 0 1-.41-1.26v-8.34a3.87 3.87 0 0 1 .41-1.72 3 3 0 0 1 .28-.46c-.06.09-.13.17-.19.28Z"
                    style={{
                        opacity: 0.15,
                        transformOrigin: "190.766px 47.575px",
                    }}
                    className="animable"
                />
                <path
                    d="m201.46 62.06-5.56-3.21v6.93a1.73 1.73 0 0 0 .4 1.26 1.43 1.43 0 0 0 .22.15c.21.11 4.83 2.78 5.46 3.15l-.07-.07a1.65 1.65 0 0 1-.41-1.24v-6.8s-.04-.11-.04-.17Z"
                    style={{
                        opacity: 0.15,
                        transformOrigin: "198.937px 64.595px",
                    }}
                    className="animable"
                />
                <path
                    d="M201.8 60.45c.24-.61.48-1.16.72-1.67l5.41-11.54-9.72 5.62-1.21 2.71c-.24.5-.48 1-.71 1.67a3 3 0 0 0-.14.39c0 .14-.08.26-.11.4v.06a2 2 0 0 1 0 .24.19.19 0 0 1 0 .08 2.25 2.25 0 0 0 0 .44l5.56 3.21a5.05 5.05 0 0 1 .2-1.61Z"
                    style={{
                        opacity: 0.3,
                        transformOrigin: "201.98px 54.65px",
                    }}
                    className="animable"
                />
                <path
                    d="M186.45 79.66v.11a3.41 3.41 0 0 0-.22.66 3 3 0 0 0-.08.64 12.13 12.13 0 0 0 1.1 5.07 7 7 0 0 0 3 3.27l5.33 3.1a.45.45 0 0 1-.1-.09 7.07 7.07 0 0 1-2.66-3.06 12 12 0 0 1-1.1-5.07 3.33 3.33 0 0 1 .33-1.41 3 3 0 0 1 .27-.44l-5.57-3.2a2.77 2.77 0 0 0-.3.42Z"
                    style={{
                        opacity: 0.15,
                        transformOrigin: "190.865px 85.875px",
                    }}
                    className="animable"
                />
                <path
                    d="m197.71 76.16-2.44-1.42a1.13 1.13 0 0 0-.34-.1 2.08 2.08 0 0 0-1.23.35l-6.44 3.73a1.76 1.76 0 0 0-.52.53l5.57 3.2a1.9 1.9 0 0 1 .53-.53l6.43-3.71c.71-.41 1.26-.48 1.63-.19l-3.17-1.85Z"
                    style={{
                        opacity: 0.3,
                        transformOrigin: "193.82px 78.5444px",
                    }}
                    className="animable"
                />
                <path
                    d="M203.92 79.47a5.75 5.75 0 0 0 3.15-1.07 12.88 12.88 0 0 0 4.05-3.6 8.13 8.13 0 0 0 1.62-4.94c0-1.82-.55-2.86-1.62-3.08a6 6 0 0 0-4.05 1.1 7.85 7.85 0 0 1-1.52 3.71 12.88 12.88 0 0 1-4.05 3.6 5.71 5.71 0 0 1-3.14 1.06 4.25 4.25 0 0 1-.65-.09l3.17 1.84 1.26.89a3.75 3.75 0 0 0 1.78.58Z"
                    style={{
                        opacity: 0.4,
                        transformOrigin: "205.225px 73.1123px",
                    }}
                    className="animable"
                />
                <path
                    d="M214.07 52.55s3.08 1.8 4.27 2.48a.46.46 0 0 0-.14-.05.34.34 0 0 0-.15-.07 7.72 7.72 0 0 0-4.86-.48Z"
                    style={{
                        fill: "#fff",
                        opacity: 0.4,
                        transformOrigin: "215.765px 53.79px",
                    }}
                    className="animable"
                />
                <path
                    d="m216.76 26.52-2.52-1.47a.81.81 0 0 0-.79.07L189 39.21a2.36 2.36 0 0 0-.84.94.64.64 0 0 1 0 .07l5.55 3.22c.06-.11.13-.19.19-.28a3 3 0 0 1 .19-.3 1.79 1.79 0 0 1 .49-.43L219 28.34a.82.82 0 0 1 .71-.11Z"
                    style={{
                        fill: "#fff",
                        opacity: 0.4,
                        transformOrigin: "203.935px 34.2093px",
                    }}
                    className="animable"
                />
                <path
                    d="M219 28.26a.75.75 0 0 1 1 .07 1.68 1.68 0 0 1 .41 1.26v8.34a4.82 4.82 0 0 1-.41 1.77c-.23.61-.45 1.13-.66 1.57l-5.3 11.28-.88 1.88a7.58 7.58 0 0 1 5.33.71 6.63 6.63 0 0 1 1.16.85c1.67 1.53 2.5 4.33 2.5 8.42A29.39 29.39 0 0 1 207.06 91a17.12 17.12 0 0 1-6.51 2.42 7.9 7.9 0 0 1-4.77-.78 7.12 7.12 0 0 1-3-3.27 12.2 12.2 0 0 1-1.1-5.07 3.3 3.3 0 0 1 .33-1.41 2.07 2.07 0 0 1 .8-1l6.43-3.72c.72-.41 1.26-.48 1.64-.2s.79.58 1.25.89a3.68 3.68 0 0 0 1.78.58 5.86 5.86 0 0 0 3.14-1.06 13.09 13.09 0 0 0 4.06-3.61 8 8 0 0 0 1.61-4.93c0-1.84-.53-2.86-1.61-3.08a6.09 6.09 0 0 0-4.06 1.08l-4.23 2.45a.75.75 0 0 1-1-.07 1.69 1.69 0 0 1-.4-1.26v-6.73a5 5 0 0 1 .35-1.78c.24-.61.48-1.16.72-1.67l5.41-11.54-13.33 7.7a.75.75 0 0 1-1-.07 1.69 1.69 0 0 1-.41-1.26v-8.33a4.06 4.06 0 0 1 .41-1.73 2.61 2.61 0 0 1 1-1.19Z"
                    style={{
                        fill: "#975ac2",
                        transformOrigin: "206.922px 60.8044px",
                    }}
                    className="animable"
                />
            </g>
        </g>
        <g
            className="animable"
            style={{
                transformOrigin: "372.703px 274.847px",
            }}
        >
            <g
                className="animable"
                style={{
                    transformOrigin: "372.703px 274.847px",
                }}
            >
                <path
                    d="m414.41 218.19 7.08-.31 4.58 8.68s-2.85 1.48-13.05 1.6Z"
                    style={{
                        fill: "#f28f8f",
                        transformOrigin: "419.545px 223.02px",
                    }}
                    className="animable"
                />
                <path
                    d="M369.6 197.3c2.7 1.27 4.17 2.74 7.07 5.1 3.58 2.92 15.93 11.31 18.58 12a170.44 170.44 0 0 0 21.36 3.44s-1.15 7 .34 10.45c-6.34.28-22.5.82-28.14-.51-6-1.42-12.66-4.8-17.78-7.77s-3.98-20.19-1.43-22.71Z"
                    style={{
                        fill: "#975ac2",
                        transformOrigin: "392.194px 212.969px",
                    }}
                    className="animable"
                />
                <g
                    style={{
                        opacity: 0.7,
                        transformOrigin: "392.194px 212.969px",
                    }}
                    className="animable"
                >
                    <path
                        d="M369.6 197.3c2.7 1.27 4.17 2.74 7.07 5.1 3.58 2.92 15.93 11.31 18.58 12a170.44 170.44 0 0 0 21.36 3.44s-1.15 7 .34 10.45c-6.34.28-22.5.82-28.14-.51-6-1.42-12.66-4.8-17.78-7.77s-3.98-20.19-1.43-22.71Z"
                        style={{
                            fill: "#fff",
                            transformOrigin: "392.194px 212.969px",
                        }}
                        className="animable"
                    />
                </g>
                <path
                    d="M371 220.06c5.12 3 11.74 6.35 17.78 7.77 4.08 1 13.68.95 21.08.76a118.81 118.81 0 0 1-19-3.06 73.51 73.51 0 0 1-11.77-6.2c-3.33-2.37-3.53-6.62-5.23-12.77-2.26-8.16-4.25-9.26-4.25-9.26-2.56 2.52-3.69 19.79 1.39 22.76Z"
                    style={{
                        opacity: 0.1,
                        transformOrigin: "388.65px 213px",
                    }}
                    className="animable"
                />
                <path
                    d="M409.89 228.59a14.48 14.48 0 0 1 .31-8.69s-2.06 2-1.62 8.72Z"
                    style={{
                        fill: "#975ac2",
                        transformOrigin: "409.359px 224.26px",
                    }}
                    className="animable"
                />
                <path
                    d="M409.89 228.59a14.48 14.48 0 0 1 .31-8.69s-2.06 2-1.62 8.72Z"
                    style={{
                        opacity: 0.1,
                        transformOrigin: "409.359px 224.26px",
                    }}
                    className="animable"
                />
                <path
                    d="M424.39 226.71c6-.21 8.23-3.25 9.07-8.52s.69-12.16.76-14-.47-2.46-1.2-2.56c-.27 0-1.43.25-1.56 2.2-.24 3.56-.33 5.75-1 5.72s-.57-2.66-.51-6.25c0-2.42 0-4.46-1.4-4.46s-1.79 1.44-1.86 4.71 0 5.7-.86 5.77c-.7 0-.56-3.43-.72-5.67s-.15-3.58-1.55-3.55-1.61 1.83-1.56 4a86.09 86.09 0 0 1-.23 9c-.39 1.29-1.73-1.89-2.71-3.2-1.61-2.15-3.58-1.17-2.78.79a38.83 38.83 0 0 1 2.18 7.4c.42 2.49 1.43 8.64 5.93 8.62Z"
                    style={{
                        fill: "#ffa8a7",
                        transformOrigin: "425.161px 212.775px",
                    }}
                    className="animable"
                />
                <path
                    d="M424.36 215.82s3.62 3.77 2.32 7.8a5.35 5.35 0 0 0 .65-5.4 4.09 4.09 0 0 0-2.97-2.4Z"
                    style={{
                        fill: "#f28f8f",
                        transformOrigin: "426.07px 219.72px",
                    }}
                    className="animable"
                />
                <path
                    d="M345.39 404.83c-.13 1.14-.28 4.34-6.07 5.13s-9.44-1.12-11-3.9-1.19-5.06-1.44-7.64-2.37-3.95-3-5.28c-.9-1.95.42-5 .42-5Z"
                    style={{
                        fill: "#263238",
                        transformOrigin: "334.478px 399.14px",
                    }}
                    className="animable"
                />
                <path
                    d="M387.63 395.77a3.49 3.49 0 0 1-.38 2.8 12.16 12.16 0 0 1-9.28 2.48 22.39 22.39 0 0 1-9.81-3.85 12.92 12.92 0 0 0-7.58-2.18c-2.79-.1-4.82-.72-5-1.45-.37-1.28-.37-2.1.23-2.06Z"
                    style={{
                        fill: "#263238",
                        transformOrigin: "371.547px 396.343px",
                    }}
                    className="animable"
                />
                <path
                    d="M345 402.2a31.89 31.89 0 0 0-2.66-3.17 28.64 28.64 0 0 1-6-15.36c0-.31-.06-.91-.37-1.1s-.63.08-1 .22a6 6 0 0 1-1.79.47 33.38 33.38 0 0 1-4.83-.19c-.4.05-.52 1.29-.49 2.62-.73-.46-1-1.38-1.62-1.91-.36-.29-.51-.3-.51-.77v-.9c-.52-.15-1 1.87-1.4 3.41-.5 1.78-1.12 3.79-.42 5.6a15.72 15.72 0 0 0 1.63 2.8 11.62 11.62 0 0 1 2.1 5.12c.08.81 0 1.64.13 2.45a7.16 7.16 0 0 0 5.06 5.87c3.52 1.11 8.82.93 11.93-1.53 1.09-.83.72-2.68.24-3.63Z"
                    style={{
                        fill: "#455a64",
                        transformOrigin: "334.533px 395.057px",
                    }}
                    className="animable"
                />
                <path
                    d="M385.29 392c-.77-.24-1.53-.52-2.28-.82a41.85 41.85 0 0 1-6.07-3c-.85-.52-1.69-1.06-2.51-1.63s-1.65-1.27-2.47-1.93a8.81 8.81 0 0 1-1.18-1.26 13 13 0 0 1-1.74-2.82 1 1 0 0 0-.43-.57.84.84 0 0 0-.82.17 4 4 0 0 1-.64.43l-.68.28a7.85 7.85 0 0 1-2.28.56c-2.94.26-3-.33-3.16.62a7.93 7.93 0 0 0 0 1.06c-1.55-.25-2.77-.76-2.84-1.34l-.18-1.88c-2.31-.32-2.08 2.38-2.36 5.34-.23 2.54-.82 4.73-.12 6.58 2.33 2 6.46 1.54 8.81 1.93 3.32.55 4.88 3 9.5 4.61 7.44 2.58 12.15-.4 13.54-1.69.9-1.64 1.08-3.59-2.09-4.64Z"
                    style={{
                        fill: "#455a64",
                        transformOrigin: "371.574px 389.596px",
                    }}
                    className="animable"
                />
                <path
                    d="M329.2 250.14c-.93 9-1.91 22.55-2.29 33.12-.7 19.86-.43 44.69-.43 44.69a68.59 68.59 0 0 0-2.14 12.73c-.47 12.69-.38 44.1-.38 44.1s5.26 5.3 13.13 1.14c0 0 7-42.87 8.92-55.38 1.87-11.93 5.5-38 5.5-38l1.64 36.05a52.37 52.37 0 0 0-1.23 16.26c.42 5.81 3.74 37.44 3.74 37.44 3 2.84 11.84 1.3 13.77-1 0 0 3.09-45.34 3.43-51.47.74-13.26 1-63.83 0-71.5s-43.66-8.18-43.66-8.18Z"
                    style={{
                        fill: "#263238",
                        transformOrigin: "348.735px 318.827px",
                    }}
                    className="animable"
                />
                <path
                    d="m351.51 292.56 2.31-15.29a30.68 30.68 0 0 0 11-4.64s-1.8 4.08-8.82 7l-2.28 14.23-.55 34.75Z"
                    className="animable"
                    style={{
                        transformOrigin: "358.165px 300.62px",
                    }}
                />
                <path
                    d="M340 155.33s-.21 0-.54.11a2.48 2.48 0 0 0-1.33-2.8 2.67 2.67 0 0 0-3.45 1.41l3.76 1.73a5.24 5.24 0 0 0-2.86 2.44c-1 2.12.33 6.64 1.7 12.22a79 79 0 0 0 3 10.34c.63 1.63 1.77 1.68 1.77 1.68v-5.57l-.24-4.61s3-4.05 3.29-7.37c.41-4.26-.48-6-.48-6Z"
                    style={{
                        fill: "#263238",
                        transformOrigin: "339.944px 167.452px",
                    }}
                    className="animable"
                />
                <path
                    d="M342 171.54c-1.11 1-2-1.53-2.95-2.51s-4-2.3-5.5.91 1.39 7.71 3.68 8.77c3.34 1.55 4.84-1.82 4.84-1.82v13.93c3.52 6.35 11.29 6.14 14.89 7a12.33 12.33 0 0 0-.14-6.25v-4.54a16.7 16.7 0 0 0 4.6.25c3-.48 4.67-3 5.58-6.28 1.47-5.29 1.77-14.18-.27-24.45-3.4-2.63-14.92-2.21-22.06 2.32.52 9.13-1.53 11.7-2.67 12.67Z"
                    style={{
                        fill: "#ffa8a7",
                        transformOrigin: "350.659px 176.373px",
                    }}
                    className="animable"
                />
                <path
                    d="M356.82 187.06s-6.79-1.34-9.17-2.6a7.88 7.88 0 0 1-3.29-3.23 10.64 10.64 0 0 0 1.88 3.82c1.74 2.21 10.59 3.82 10.59 3.82Z"
                    style={{
                        fill: "#f28f8f",
                        transformOrigin: "350.595px 185.05px",
                    }}
                    className="animable"
                />
                <path
                    d="M353.73 169.64a1.45 1.45 0 1 1-1.45-1.45 1.45 1.45 0 0 1 1.45 1.45Z"
                    style={{
                        fill: "#263238",
                        transformOrigin: "352.28px 169.64px",
                    }}
                    className="animable"
                />
                <path
                    d="M365.24 168.58a1.45 1.45 0 1 1-1.45-1.45 1.45 1.45 0 0 1 1.45 1.45Z"
                    style={{
                        fill: "#263238",
                        transformOrigin: "363.79px 168.58px",
                    }}
                    className="animable"
                />
                <path
                    d="m351.77 165.78-3 1.59a1.79 1.79 0 0 1 .75-2.37 1.67 1.67 0 0 1 2.25.78Z"
                    style={{
                        fill: "#263238",
                        transformOrigin: "350.177px 166.098px",
                    }}
                    className="animable"
                />
                <path
                    d="m354.48 178.6 5.09 1.32a2.57 2.57 0 0 1-3.15 2 2.75 2.75 0 0 1-1.94-3.32Z"
                    style={{
                        fill: "#b16668",
                        transformOrigin: "356.984px 180.299px",
                    }}
                    className="animable"
                />
                <path
                    d="M355 179.67a3.05 3.05 0 0 0-.52.05 2.73 2.73 0 0 0 2 2.17 2.41 2.41 0 0 0 1.28 0 2.77 2.77 0 0 0-2.76-2.22Z"
                    style={{
                        fill: "#f28f8f",
                        transformOrigin: "356.12px 180.823px",
                    }}
                    className="animable"
                />
                <path
                    d="m366.44 166.06-3.12-1.48a1.66 1.66 0 0 1 2.25-.86 1.82 1.82 0 0 1 .87 2.34Z"
                    style={{
                        fill: "#263238",
                        transformOrigin: "364.952px 164.809px",
                    }}
                    className="animable"
                />
                <path
                    style={{
                        fill: "#f28f8f",
                        transformOrigin: "361.01px 172.585px",
                    }}
                    className="animable"
                    d="m358.23 167.93.91 9.31 4.65-2.09-5.56-7.22z"
                />
                <path
                    d="M336.08 190.82c-6.18 2.21-10.77 4.37-15.06 8.05 0 0 4.44 19.27 7.22 29.88 2.52 9.67.16 29.37.16 29.37s3.89 5.88 26 5.24C366.9 263 373 259 373 259s1.06-21.73.58-39.9c-.38-14.62-1.44-18.15-3.93-21.81-1.8-1.22-11.75-4.9-11.75-4.9a26.09 26.09 0 0 0-.86 5.45c-3.68-5.66-20.96-7.02-20.96-7.02Z"
                    style={{
                        fill: "#975ac2",
                        transformOrigin: "347.362px 227.114px",
                    }}
                    className="animable"
                />
                <path
                    d="M336.08 190.82c-6.18 2.21-10.77 4.37-15.06 8.05 0 0 4.44 19.27 7.22 29.88 2.52 9.67.16 29.37.16 29.37s3.89 5.88 26 5.24C366.9 263 373 259 373 259s1.06-21.73.58-39.9c-.38-14.62-1.44-18.15-3.93-21.81-1.8-1.22-11.75-4.9-11.75-4.9a26.09 26.09 0 0 0-.86 5.45c-3.68-5.66-20.96-7.02-20.96-7.02Z"
                    style={{
                        fill: "#fff",
                        opacity: 0.3,
                        transformOrigin: "347.362px 227.114px",
                    }}
                    className="animable"
                />
                <path
                    d="M333.15 240.67c-.26-6.51-1.67-18.85-1.57-28.2l-4.41-6.69-2.57 8.31c1.23 5.1 2.56 10.54 3.64 14.66 2.52 9.67.16 29.37.16 29.37s3.89 5.88 26 5.24h.4a37.07 37.07 0 0 1-11.87-3.36c-6.87-3.4-9.52-12.81-9.78-19.33Z"
                    style={{
                        opacity: 0.1,
                        transformOrigin: "339.7px 234.594px",
                    }}
                    className="animable"
                />
                <path
                    d="M342.1 184.93V186c.2 1 2.25 3.45 7.41 5.77a17.37 17.37 0 0 1 7.48 6.06s-1.76-2.71-3.93-1.28-4.37 5-5.49 5-4.86-3.57-7.79-6.63c-2.45-2.58-3.7-4.13-3.7-4.13s4.01-5.79 6.02-5.86Z"
                    style={{
                        fill: "#975ac2",
                        transformOrigin: "346.535px 193.24px",
                    }}
                    className="animable"
                />
                <path
                    d="M357 197.85c1.57-3.76 4.4-.55 4.58-.53.82.05-1.79-6.86-4.73-8.76v3Z"
                    style={{
                        fill: "#975ac2",
                        transformOrigin: "359.291px 193.205px",
                    }}
                    className="animable"
                />
                <path
                    d="M342.1 184.93V186c.2 1 2.25 3.45 7.41 5.77a17.37 17.37 0 0 1 7.48 6.06s-1.76-2.71-3.93-1.28-4.37 5-5.49 5-4.86-3.57-7.79-6.63c-2.45-2.58-3.7-4.13-3.7-4.13s4.01-5.79 6.02-5.86Z"
                    style={{
                        fill: "#fff",
                        opacity: 0.65,
                        transformOrigin: "346.535px 193.24px",
                    }}
                    className="animable"
                />
                <path
                    d="M357 197.85c1.57-3.76 4.4-.55 4.58-.53.82.05-1.79-6.86-4.73-8.76v3Z"
                    style={{
                        fill: "#fff",
                        opacity: 0.65,
                        transformOrigin: "359.291px 193.205px",
                    }}
                    className="animable"
                />
                <path
                    d="M361.11 262.77c.26-13.86.62-49.46-4.12-64.92 0 0 4.47 32.91 2.05 65.19q1.08-.12 2.07-.27Z"
                    style={{
                        fill: "#975ac2",
                        transformOrigin: "359.116px 230.445px",
                    }}
                    className="animable"
                />
                <path
                    d="M361.11 262.77c.26-13.86.62-49.46-4.12-64.92 0 0 4.47 32.91 2.05 65.19q1.08-.12 2.07-.27Z"
                    style={{
                        opacity: 0.1,
                        transformOrigin: "359.116px 230.445px",
                    }}
                    className="animable"
                />
                <path
                    d="M338.56 214.48a38.54 38.54 0 0 0 14.09-1.7l.22 2.72a35 35 0 0 1-14 1.46Z"
                    style={{
                        fill: "#975ac2",
                        transformOrigin: "345.715px 214.955px",
                    }}
                    className="animable"
                />
                <path
                    d="M338.56 214.48a38.54 38.54 0 0 0 14.09-1.7l.22 2.72a35 35 0 0 1-14 1.46Z"
                    style={{
                        opacity: 0.1,
                        transformOrigin: "345.715px 214.955px",
                    }}
                    className="animable"
                />
                <g
                    className="animable"
                    style={{
                        transformOrigin: "368.423px 214.581px",
                    }}
                >
                    <path
                        d="M373.17 208.11a.2.2 0 0 0-.07-.2c-.05 0-.38-.23-.43-.26-.05 0-.12 0-.22.06a3.15 3.15 0 0 1-3.12.34 2.24 2.24 0 0 1-.35-.34.32.32 0 0 0-.09-.08l-.44-.27c-.1-.05-.2 0-.27.14-.93 2.11-2.84 4.22-4.08 4.72a.7.7 0 0 0-.25.17.53.53 0 0 0-.15.35c-.09 2.75 1.27 7.19 4.07 8.76a5.58 5.58 0 0 0 .52.32c4.03-3.97 4.77-10.45 4.88-13.71Z"
                        style={{
                            fill: "#ebebeb",
                            transformOrigin: "368.435px 214.581px",
                        }}
                        className="animable"
                    />
                    <path
                        d="M367.74 221.45c-2.8-1.57-4.16-6-4.07-8.76a.55.55 0 0 1 .06-.22l.43.28a.46.46 0 0 0-.05.21c-.11 2.6 1.12 6.72 3.63 8.49Z"
                        style={{
                            fill: "#e0e0e0",
                            transformOrigin: "365.703px 216.96px",
                        }}
                        className="animable"
                    />
                    <path
                        d="M373.17 208.11c-.11 3.26-.85 9.74-4.91 13.66-2.86-1.53-4.24-6-4.15-8.81a.53.53 0 0 1 .15-.35.74.74 0 0 1 .25-.17c1.24-.5 3.15-2.61 4.08-4.72.07-.15.16-.19.26-.14a.32.32 0 0 1 .09.08 3 3 0 0 0 3.91.28.25.25 0 0 1 .22-.07.2.2 0 0 1 .1.24Z"
                        style={{
                            fill: "#fafafa",
                            transformOrigin: "368.643px 214.665px",
                        }}
                        className="animable"
                    />
                    <path
                        d="M368.85 207.58c-.1-.05-.19 0-.26.14-.93 2.11-2.84 4.22-4.08 4.72a.74.74 0 0 0-.25.17.53.53 0 0 0-.15.35c-.09 2.77 1.29 7.28 4.15 8.81a30.26 30.26 0 0 0 .59-14.19Z"
                        style={{
                            fill: "#f0f0f0",
                            transformOrigin: "366.766px 214.666px",
                        }}
                        className="animable"
                    />
                </g>
                <path
                    d="M346.57 160.89s9.32 4.54 19.32.61c10.27-4.05 1.27-6.92 1.27-6.92Z"
                    style={{
                        fill: "#263238",
                        transformOrigin: "358.689px 158.841px",
                    }}
                    className="animable"
                />
                <path
                    d="M367.42 141c-7.75-1.72-16.22-2.63-26.39 1.54s-12.73 10.4-12.73 10.4 9.86 3.38 18.19 1.55S367.42 141 367.42 141Z"
                    style={{
                        fill: "#455a64",
                        transformOrigin: "347.86px 147.294px",
                    }}
                    className="animable"
                />
                <path
                    d="M334.13 158.62s-5.45-4.43-5.83-5.73a34.25 34.25 0 0 0 11.82-1.45c6.68-2 13.93-8.7 21.41-10.25s10.4 2 10.4 2a35.42 35.42 0 0 1-4.74 8.65s-2.61 5.09-11.41 6.75-21.65.03-21.65.03Z"
                    style={{
                        fill: "#37474f",
                        transformOrigin: "350.115px 150.067px",
                    }}
                    className="animable"
                />
                <path
                    d="M334.13 158.62a14.94 14.94 0 0 0 .42 1.74 8.37 8.37 0 0 0 .81 1.47c3.12.61 10.62 1.1 20.51-1.26 6.2-1.49 9.06-3.21 10.24-4.45a3.36 3.36 0 0 0 1.2-2.9l-.12-1.37s-2.06 2.73-12.2 5.26a70.36 70.36 0 0 1-20.86 1.51Z"
                    style={{
                        fill: "#975ac2",
                        transformOrigin: "350.727px 157.092px",
                    }}
                    className="animable"
                />
                <path
                    d="M334.13 158.62a14.94 14.94 0 0 0 .42 1.74 8.37 8.37 0 0 0 .81 1.47c3.12.61 10.62 1.1 20.51-1.26 6.2-1.49 9.06-3.21 10.24-4.45a3.36 3.36 0 0 0 1.2-2.9l-.12-1.37s-2.06 2.73-12.2 5.26a70.36 70.36 0 0 1-20.86 1.51Z"
                    style={{
                        opacity: 0.05,
                        transformOrigin: "350.727px 157.092px",
                    }}
                    className="animable"
                />
                <path
                    d="M339.53 295.16c-1-1.46-3.31-2.78-4.17-3.64-1.52-1.54-3.74-4.79-3.41-5.39s1.26.18 3.2.17c3 0 3.82-1.18 3.79-2.28 0-.86-1.83-.7-4-1.18-1.91-.61-4.2-2.76-5.45-4.45s-2.26-6.1-2.26-6.1-6.49.09-11 3.16c0 0 1.29 6.7 2.77 11.45 1.65 5.33 5.39 11.21 11.08 12.53a13.83 13.83 0 0 0 7.16-.36 5.29 5.29 0 0 0 1.9-.94 2 2 0 0 0 .39-2.97Z"
                    style={{
                        fill: "#ffa8a7",
                        transformOrigin: "328.125px 286.015px",
                    }}
                    className="animable"
                />
                <path
                    d="M321 198.87s-1-.2-2.68 3.66a61.94 61.94 0 0 0-3.27 11.53c-.67 3.22-3.87 20.13-3.87 27.4s2.17 21.88 5 34.33c3.48.35 9.46-.55 11.46-2.83-1.31-12.42-2.41-18.81-2.11-28.58 2-14.5 7.87-29.69 8.12-31.38.53-3.71-5.33-15.37-12.65-14.13Z"
                    style={{
                        fill: "#975ac2",
                        transformOrigin: "322.432px 237.321px",
                    }}
                    className="animable"
                />
                <path
                    d="M321 198.87s-1-.2-2.68 3.66a61.94 61.94 0 0 0-3.27 11.53c-.67 3.22-3.87 20.13-3.87 27.4s2.17 21.88 5 34.33c3.48.35 9.46-.55 11.46-2.83-1.31-12.42-2.41-18.81-2.11-28.58 2-14.5 7.87-29.69 8.12-31.38.53-3.71-5.33-15.37-12.65-14.13Z"
                    style={{
                        fill: "#fff",
                        opacity: 0.65,
                        transformOrigin: "322.432px 237.321px",
                    }}
                    className="animable"
                />
                <path
                    d="M316.27 260c-1.74-8.5-4.59-25.14-2.64-38.23-1.12 6.43-2.43 15-2.43 19.69 0 7.27 2.17 21.88 5 34.33a20.33 20.33 0 0 0 4.16-.08c-1.25-4.11-3.02-10.47-4.09-15.71Z"
                    style={{
                        opacity: 0.1,
                        transformOrigin: "315.78px 248.815px",
                    }}
                    className="animable"
                />
                <path
                    d="M314.94 269.69c2.84.18 7.89-.62 10-2 0 0-3.68 1.63-10.19.7Z"
                    style={{
                        fill: "#975ac2",
                        transformOrigin: "319.845px 268.703px",
                    }}
                    className="animable"
                />
                <path
                    d="M314.94 269.69c2.84.18 7.89-.62 10-2 0 0-3.68 1.63-10.19.7Z"
                    style={{
                        opacity: 0.1,
                        transformOrigin: "319.845px 268.703px",
                    }}
                    className="animable"
                />
                <g
                    className="animable"
                    style={{
                        transformOrigin: "361.261px 150.42px",
                    }}
                >
                    <path
                        d="M364.79 145.63v-.15l-.32-.2h-.17a2.37 2.37 0 0 1-2.33.25 1.6 1.6 0 0 1-.26-.26.19.19 0 0 0-.07-.06l-.32-.2c-.07 0-.14 0-.19.11a7.61 7.61 0 0 1-3.05 3.52.5.5 0 0 0-.19.13.41.41 0 0 0-.11.26c-.07 2 .95 5.37 3 6.54a3 3 0 0 0 .38.24c3-2.91 3.55-7.74 3.63-10.18Z"
                        style={{
                            fill: "#ebebeb",
                            transformOrigin: "361.283px 150.41px",
                        }}
                        className="animable"
                    />
                    <path
                        d="M360.74 155.59c-2.1-1.17-3.11-4.49-3-6.54a.42.42 0 0 1 0-.16l.33.2a.29.29 0 0 0 0 .16c-.07 1.94.79 5.02 2.67 6.34Z"
                        style={{
                            fill: "#e0e0e0",
                            transformOrigin: "359.236px 152.24px",
                        }}
                        className="animable"
                    />
                    <path
                        d="M364.79 145.63c-.08 2.44-.63 7.27-3.67 10.2-2.13-1.14-3.16-4.51-3.09-6.58a.36.36 0 0 1 .11-.26.59.59 0 0 1 .18-.13 7.5 7.5 0 0 0 3.05-3.52c.05-.11.13-.15.2-.11a.19.19 0 0 1 .07.06 2.19 2.19 0 0 0 2.92.21c.07-.05.12-.06.16 0s.08.05.07.13Z"
                        style={{
                            fill: "#fafafa",
                            transformOrigin: "361.409px 150.522px",
                        }}
                        className="animable"
                    />
                    <path
                        d="M361.57 145.23c-.07 0-.15 0-.2.11a7.5 7.5 0 0 1-3.05 3.52.59.59 0 0 0-.18.13.36.36 0 0 0-.11.26c-.07 2.07 1 5.44 3.09 6.58a22.54 22.54 0 0 0 .45-10.6Z"
                        style={{
                            fill: "#f0f0f0",
                            transformOrigin: "360.012px 150.53px",
                        }}
                        className="animable"
                    />
                </g>
            </g>
        </g>
        <g
            className="animable"
            style={{
                transformOrigin: "341.81px 91.87px",
            }}
        >
            <g
                className="animable"
                style={{
                    transformOrigin: "341.81px 91.87px",
                }}
            >
                <g
                    className="animable"
                    style={{
                        transformOrigin: "341.81px 91.87px",
                    }}
                >
                    <path
                        d="m349.86 130-5.46-12.44 4.39-12.67v-7.81l-13.44 7.76v7.76l5.78 12.18a.87.87 0 0 0 .39.35Z"
                        style={{
                            fill: "#975ac2",
                            transformOrigin: "342.605px 113.54px",
                        }}
                        className="animable"
                    />
                    <path
                        d="m349.86 130-5.46-12.44 4.39-12.67v-7.81l-13.44 7.76v7.76l5.78 12.18a.87.87 0 0 0 .39.35Z"
                        style={{
                            opacity: 0.2,
                            transformOrigin: "342.605px 113.54px",
                        }}
                        className="animable"
                    />
                    <path
                        d="M390.07 55.14a8.93 8.93 0 0 0-4-7l-3.28-1.89a8.88 8.88 0 0 0-8.06 0l-77.12 44.61a8.9 8.9 0 0 0-4 7v30.74a8.93 8.93 0 0 0 4 7l3.28 1.89a8.88 8.88 0 0 0 8.06 0l34.84-20 5.77 12.17a.86.86 0 0 0 1.55-.15l6.1-19.77L386 92.88a8.91 8.91 0 0 0 4-7Z"
                        style={{
                            fill: "#975ac2",
                            transformOrigin: "341.84px 91.87px",
                        }}
                        className="animable"
                    />
                    <path
                        d="M293.58 128.6a8.93 8.93 0 0 0 4 7l3.28 1.89a9 9 0 0 0 7.37.33c-1.89.71-3.34-.36-3.34-2.65v-30.79a8.2 8.2 0 0 1 1.18-4l-11.34-6.55a8.26 8.26 0 0 0-1.18 4Z"
                        style={{
                            opacity: 0.2,
                            transformOrigin: "300.89px 116.142px",
                        }}
                        className="animable"
                    />
                    <path
                        d="M389.94 54c-.47-1.71-2-2.25-3.89-1.18L309 97.41a7.84 7.84 0 0 0-2.84 3l-11.33-6.54a8 8 0 0 1 2.83-3l77.08-44.6a9 9 0 0 1 8.07 0l3.29 1.9a8.93 8.93 0 0 1 3.84 5.83Z"
                        style={{
                            fill: "#fff",
                            opacity: 0.5,
                            transformOrigin: "342.385px 72.8624px",
                        }}
                        className="animable"
                    />
                </g>
                <path
                    d="M310.48 123.13v-16.25a2.14 2.14 0 0 1 .15-.88 1.11 1.11 0 0 1 .47-.51l4.61-2.67c.17-.09.29-.06.37.1a2.33 2.33 0 0 1 .12.91v.8a3.6 3.6 0 0 1-.12 1.05.84.84 0 0 1-.37.52l-2.61 1.51v3.77l2.46-1.42c.17-.1.29-.07.37.09a2.44 2.44 0 0 1 .11.92v.8a3.74 3.74 0 0 1-.11 1 .87.87 0 0 1-.37.52l-2.46 1.42v6.76a1.64 1.64 0 0 1-1 1.39l-.67.38c-.62.43-.95.34-.95-.21Z"
                    style={{
                        fill: "#455a64",
                        transformOrigin: "313.342px 113.19px",
                    }}
                    className="animable"
                />
                <path
                    d="M317.25 111q0-9.22 4.39-11.77 2.14-1.23 3.26.37c.74 1.06 1.12 3.18 1.12 6.34a21.71 21.71 0 0 1-1.12 7.64 7.75 7.75 0 0 1-3.26 4.13q-4.38 2.5-4.39-6.71Zm5.38 2.24a6.69 6.69 0 0 0 .55-2.11 27.55 27.55 0 0 0 .19-3.66 22.45 22.45 0 0 0-.19-3.41 2.52 2.52 0 0 0-.55-1.48c-.25-.2-.57-.18-1 0a2.53 2.53 0 0 0-1 1.08 7 7 0 0 0-.57 2.12 27.42 27.42 0 0 0-.19 3.64 22.69 22.69 0 0 0 .19 3.42 2.51 2.51 0 0 0 .57 1.48.83.83 0 0 0 1 0 2.63 2.63 0 0 0 1-1.12Z"
                    style={{
                        fill: "#455a64",
                        transformOrigin: "321.641px 108.47px",
                    }}
                    className="animable"
                />
                <path
                    d="M327.56 113.27V97a2 2 0 0 1 .16-.88 1.11 1.11 0 0 1 .51-.54L331 94a2.29 2.29 0 0 1 2.48-.26c.63.43.94 1.55.94 3.37a9 9 0 0 1-1.59 5.28v.11a1.13 1.13 0 0 1 .67.64 4.44 4.44 0 0 1 .45 1.29l1 4.38.05.28c0 .46-.34.89-1 1.29l-.58.34c-.59.34-.93.31-1-.11l-.89-4.39a1.08 1.08 0 0 0-.34-.6c-.13-.08-.33 0-.61.12l-.4.23v5.83a1.67 1.67 0 0 1-1 1.41l-.57.33c-.72.36-1.05.28-1.05-.27Zm3.52-11.63a1.69 1.69 0 0 0 .62-.93 5.19 5.19 0 0 0 .26-1.8 2.64 2.64 0 0 0-.26-1.44.47.47 0 0 0-.68-.11l-.88.51v4.31Z"
                    style={{
                        fill: "#455a64",
                        transformOrigin: "331.279px 103.625px",
                    }}
                    className="animable"
                />
                <path
                    d="M336.35 108.72a1.09 1.09 0 0 1-.15-.7V92a2.09 2.09 0 0 1 .15-.85 1.11 1.11 0 0 1 .47-.51l3-1.73c2.35-1.36 3.52-.58 3.52 2.32a8.92 8.92 0 0 1-1.51 5.13v.09a1.28 1.28 0 0 1 1.34.73 5 5 0 0 1 .49 2.48 9.46 9.46 0 0 1-1 4.24 7 7 0 0 1-2.84 3l-3.05 1.77c-.16.15-.32.15-.42.05Zm3.49-12.47a1.85 1.85 0 0 0 .79-1 5.05 5.05 0 0 0 .26-1.82 2.79 2.79 0 0 0-.24-1.44q-.24-.34-.78 0l-1.19.69v4.25Zm.12 7.51a2.12 2.12 0 0 0 .91-1.06 5.23 5.23 0 0 0 .29-2 2.65 2.65 0 0 0-.28-1.52c-.19-.23-.5-.22-.92 0l-1.28.73v4.52Z"
                    style={{
                        fill: "#455a64",
                        transformOrigin: "339.93px 98.5254px",
                    }}
                    className="animable"
                />
                <path
                    d="M345.15 103.11V86.6a1.62 1.62 0 0 1 1-1.41l.71-.41c.63-.37.95-.26.95.3v16.51a1.63 1.63 0 0 1-.95 1.41l-.71.4c-.68.38-1 .28-1-.29Z"
                    style={{
                        fill: "#455a64",
                        transformOrigin: "346.48px 94.0953px",
                    }}
                    className="animable"
                />
                <path
                    d="M349.78 101a1 1 0 0 1-.16-.7v-16a2 2 0 0 1 .16-.88 1 1 0 0 1 .46-.51l3.19-1.84q2.18-1.26 3.21.39c.68 1.1 1 3.17 1 6.19a22.19 22.19 0 0 1-1 7.38 7.47 7.47 0 0 1-3.21 4.1l-3.19 1.83c-.24.11-.37.12-.46.04Zm3.56-5.19a3.08 3.08 0 0 0 1.28-2 20.41 20.41 0 0 0 .38-4.59 14.66 14.66 0 0 0-.38-4.15c-.26-.7-.68-.89-1.28-.54l-1.07.61V96.4Z"
                    style={{
                        fill: "#455a64",
                        transformOrigin: "353.631px 90.7885px",
                    }}
                    className="animable"
                />
                <path
                    d="M359.44 95.39a1.11 1.11 0 0 1-.15-.7v-16a2.14 2.14 0 0 1 .15-.88 1.11 1.11 0 0 1 .47-.51l3.19-1.84q2.17-1.26 3.2.39t1 6.19a22 22 0 0 1-1 7.38 7.41 7.41 0 0 1-3.2 4.1l-3.19 1.83c-.21.13-.37.14-.47.04Zm3.57-5.2a3.07 3.07 0 0 0 1.28-2 20.48 20.48 0 0 0 .38-4.59 14.66 14.66 0 0 0-.38-4.15c-.26-.71-.69-.89-1.28-.55l-1.07.62v11.3Z"
                    style={{
                        fill: "#455a64",
                        transformOrigin: "363.298px 85.1859px",
                    }}
                    className="animable"
                />
                <path
                    d="M369.11 89.81a1.11 1.11 0 0 1-.15-.7v-16a2.12 2.12 0 0 1 .15-.87 1.18 1.18 0 0 1 .47-.52l4.94-2.85a.23.23 0 0 1 .37.09 2.39 2.39 0 0 1 .12.92v.8a3.64 3.64 0 0 1-.12 1 .87.87 0 0 1-.37.52l-2.95 1.8v3.74l2.62-1.51c.17-.09.29-.06.37.1a2.3 2.3 0 0 1 .12.91V78a3.6 3.6 0 0 1-.12 1.05.84.84 0 0 1-.37.52l-2.62 1.51v4.18l3-1.71c.17-.1.29-.07.36.1a2.63 2.63 0 0 1 .11.92v.8a4 4 0 0 1-.11 1 .82.82 0 0 1-.36.52l-5 2.86c-.2.15-.36.16-.46.06Z"
                    style={{
                        fill: "#455a64",
                        transformOrigin: "371.998px 79.343px",
                    }}
                    className="animable"
                />
                <path
                    d="M376.53 85V68.48a1.61 1.61 0 0 1 1-1.38l.43-.26a1 1 0 0 1 .54-.16c.13 0 .24.14.33.38l3 6.67a13.89 13.89 0 0 1 .57 1.69l.07-.1c-.09-.84-.14-1.49-.14-2v-8.19a1.62 1.62 0 0 1 1-1.38l.41-.23c.64-.38 1-.29 1 .26v16.51a1.64 1.64 0 0 1-1 1.39l-.32.18a1.06 1.06 0 0 1-.56.18c-.14 0-.26-.14-.35-.38l-3.2-6.92a10.16 10.16 0 0 1-.45-1.39l-.08.12a14.88 14.88 0 0 1 .13 1.68v8.49a1.62 1.62 0 0 1-1 1.39l-.4.23c-.65.37-.98.28-.98-.26Z"
                    style={{
                        fill: "#455a64",
                        transformOrigin: "380.635px 74.3864px",
                    }}
                    className="animable"
                />
            </g>
        </g>
        <g
            className="animable"
            style={{
                transformOrigin: "108.785px 359.859px",
            }}
        >
            <g
                className="animable"
                style={{
                    transformOrigin: "108.785px 359.859px",
                }}
            >
                <g
                    className="animable"
                    style={{
                        transformOrigin: "108.966px 399.099px",
                    }}
                >
                    <path
                        d="M124.7 425.24c8.41-8.69 13.36-44 5.15-50.91H88.08c-8.2 6.88-3.27 42.21 5.15 50.9l.23.24.29.28a8.57 8.57 0 0 0 .76.69l.2.16.63.48a10 10 0 0 0 1.09.7c6.92 4.05 18.15 4.05 25.07 0a10 10 0 0 0 1.09-.7c.21-.15.4-.3.6-.46l.24-.19c.27-.22.51-.44.74-.66l.33-.33Z"
                        style={{
                            fill: "#455a64",
                            transformOrigin: "108.966px 402.574px",
                        }}
                        className="animable"
                    />
                    <path
                        d="M91.71 371.55c-9.53 5.57-9.53 14.59 0 20.15s25 5.56 34.51 0 9.53-14.58 0-20.15-24.98-5.55-34.51 0Z"
                        style={{
                            fill: "#455a64",
                            transformOrigin: "108.961px 381.625px",
                        }}
                        className="animable"
                    />
                    <g
                        style={{
                            opacity: 0.1,
                            transformOrigin: "108.961px 381.625px",
                        }}
                        className="animable"
                    >
                        <path
                            d="M91.71 371.55c-9.53 5.57-9.53 14.59 0 20.15s25 5.56 34.51 0 9.53-14.58 0-20.15-24.98-5.55-34.51 0Z"
                            style={{
                                fill: "#fff",
                                transformOrigin: "108.961px 381.625px",
                            }}
                            className="animable"
                        />
                    </g>
                    <path
                        d="M96.29 374.23c-7 4.08-7 10.71 0 14.79s18.35 4.09 25.35 0 7-10.71 0-14.79-18.35-4.09-25.35 0Z"
                        style={{
                            fill: "#263238",
                            transformOrigin: "108.965px 381.625px",
                        }}
                        className="animable"
                    />
                    <path
                        d="M121.63 381.25c-7-4.09-18.34-4.09-25.34 0a11.69 11.69 0 0 0-4.19 3.89 11.76 11.76 0 0 0 4.19 3.86c7 4.09 18.35 4.09 25.34 0a11.72 11.72 0 0 0 4.2-3.88 11.65 11.65 0 0 0-4.2-3.87Z"
                        style={{
                            fill: "#f5f5f5",
                            transformOrigin: "108.965px 385.125px",
                        }}
                        className="animable"
                    />
                </g>
                <g
                    className="animable"
                    style={{
                        transformOrigin: "108.785px 337.706px",
                    }}
                >
                    <path
                        d="m85.81 305.77 16.7 11.42-15.79-6a28.78 28.78 0 0 0 3.12 12.14s10.43 5.06 16.1 10.4l-13.89-4.37a15.32 15.32 0 0 0 .43 7.26c.09.32.19.65.29 1 .74 2.22 1.79 6.43 3.56 11.4a73.25 73.25 0 0 0 5.74 12.56 51.3 51.3 0 0 0 3.82 5.64l.26.34q3.87-2.58 8-5.05c1.6-4.1 3.37-14.06 3.69-22.14 1.21-30.93-23.23-46.89-42.31-51.47.06.01 7.04 7.6 10.28 16.87Z"
                        style={{
                            fill: "#975ac2",
                            transformOrigin: "96.7066px 328.23px",
                        }}
                        className="animable"
                    />
                    <path
                        d="m85.81 305.77 16.7 11.42-15.79-6a28.78 28.78 0 0 0 3.12 12.14s10.43 5.06 16.1 10.4l-13.89-4.37a15.32 15.32 0 0 0 .43 7.26c.09.32.19.65.29 1 .74 2.22 1.79 6.43 3.56 11.4a73.25 73.25 0 0 0 5.74 12.56 51.3 51.3 0 0 0 3.82 5.64l.26.34q3.87-2.58 8-5.05c1.6-4.1 3.37-14.06 3.69-22.14 1.21-30.93-23.23-46.89-42.31-51.47.06.01 7.04 7.6 10.28 16.87Z"
                        style={{
                            opacity: 0.3,
                            transformOrigin: "96.7066px 328.23px",
                        }}
                        className="animable"
                    />
                    <path
                        d="M99.13 306.12a22.94 22.94 0 0 1 4.34 5.23 48.28 48.28 0 0 1 3.06 6.1 62.65 62.65 0 0 1 3.74 13.08 57.68 57.68 0 0 1-1.47 26.89.44.44 0 0 0 .85.26 58.35 58.35 0 0 0 1.06-27.23 62.82 62.82 0 0 0-4-13.09 47.87 47.87 0 0 0-3.16-6.07 23.37 23.37 0 0 0-4.42-5.17Z"
                        style={{
                            fill: "#fafafa",
                            transformOrigin: "105.483px 332.057px",
                        }}
                        className="animable"
                    />
                    <path
                        d="M157.52 321.57c-.38.49-6.29 5.64-15.36 21.07l-18.39 4.62 15 1.35-6.88 12-15.7 3.88 12.44 1.54s-3 12.18-11.61 17.55c-4.78 3-7.15 3.48-8.67 2.15-1.06-.94-1.52-6.71-2.58-11.84s-1.45-13.52 3-23.83a31.46 31.46 0 0 1 4.78-7.64c11.17-13.42 33.03-20.59 43.97-20.85Z"
                        style={{
                            fill: "#975ac2",
                            transformOrigin: "131.3px 354.001px",
                        }}
                        className="animable"
                    />
                    <path
                        d="M157.52 321.57c-.38.49-6.29 5.64-15.36 21.07l-18.39 4.62 15 1.35-6.88 12-15.7 3.88 12.44 1.54s-3 12.18-11.61 17.55c-4.78 3-7.15 3.48-8.67 2.15-1.06-.94-1.52-6.71-2.58-11.84s-1.45-13.52 3-23.83a31.46 31.46 0 0 1 4.78-7.64c11.17-13.42 33.03-20.59 43.97-20.85Z"
                        style={{
                            opacity: 0.15,
                            transformOrigin: "131.3px 354.001px",
                        }}
                        className="animable"
                    />
                    <path
                        d="M112.17 355.34a48.67 48.67 0 0 0-3.17 13.47 145.8 145.8 0 0 0 .22 17.45 2.92 2.92 0 0 1-.91-.51c-1.06-.94-1.52-6.71-2.58-11.84s-1.45-13.52 3-23.83a31.46 31.46 0 0 1 4.78-7.64c11.2-13.49 33.06-20.63 44-20.89-16.68 3.39-34.29 15.26-42.7 28.59a34.19 34.19 0 0 0-2.64 5.2Z"
                        style={{
                            opacity: 0.1,
                            transformOrigin: "131.275px 353.905px",
                        }}
                        className="animable"
                    />
                    <path
                        d="M140.91 327.48c-8.17 4-15.85 9.28-21.77 16.31a43.5 43.5 0 0 0-7.21 11.67 41.81 41.81 0 0 0-3 13.34h.09a53.43 53.43 0 0 1 3.72-13 50.07 50.07 0 0 1 6.94-11.55 57.58 57.58 0 0 1 9.76-9.41 75.9 75.9 0 0 1 11.5-7.28v-.08Z"
                        style={{
                            fill: "#fafafa",
                            transformOrigin: "124.935px 348.14px",
                        }}
                        className="animable"
                    />
                    <path
                        d="M60.05 333.25a33.68 33.68 0 0 1 4 0 64.21 64.21 0 0 1 15.67 2.9c1.89.59 3.78 1.26 5.66 2 .93.39 1.86.8 2.78 1.23a45 45 0 0 1 12.34 8.3 28.44 28.44 0 0 1 4.39 5.5c.16.26.33.52.48.78.39.68.73 1.36 1.07 2a38.81 38.81 0 0 1 4.56 18.87c.09 4.62-1.19 10-2 10.89a2.23 2.23 0 0 1-.38.32c-1.27.91-3.39.54-7.42-1.43-8.07-3.94-11.76-14.86-11.76-14.86l10.78-2.45-14.12-2-6.17-8.54 10.34-2.47L76 352.87a209.33 209.33 0 0 0-15.88-19.6Z"
                        style={{
                            fill: "#975ac2",
                            transformOrigin: "85.5274px 359.851px",
                        }}
                        className="animable"
                    />
                    <path
                        d="M64.1 333.22a64.21 64.21 0 0 1 15.67 2.9c1.89.59 3.78 1.26 5.66 2 .93.39 1.86.8 2.78 1.23a45 45 0 0 1 12.34 8.3 28.44 28.44 0 0 1 4.39 5.5c.16.26.33.52.48.78.39.68.73 1.36 1.07 2a38.81 38.81 0 0 1 4.51 18.9c.09 4.62-1.19 10-2 10.89a2.23 2.23 0 0 1-.38.32 2.42 2.42 0 0 1-.85.37c.57-7.2-4-25.13-9.68-32.29-6-7.45-19.73-18-38-20.85a33 33 0 0 1 4.01-.05Z"
                        style={{
                            opacity: 0.05,
                            transformOrigin: "85.5484px 359.796px",
                        }}
                        className="animable"
                    />
                    <path
                        d="M107.81 386.41a61.14 61.14 0 0 0-1.91-15.75A50.94 50.94 0 0 0 99.83 356a36 36 0 0 0-5.13-6.15 52.73 52.73 0 0 0-6.14-5.12 59.51 59.51 0 0 0-14.07-7.4h-.06a.06.06 0 0 0 0 .06 78.8 78.8 0 0 1 13.58 8 66.22 66.22 0 0 1 6 5 35.22 35.22 0 0 1 5.15 5.9 50.3 50.3 0 0 1 6.23 14.42 61.24 61.24 0 0 1 2.25 15.64l.17.06Z"
                        style={{
                            fill: "#fafafa",
                            transformOrigin: "91.1173px 361.87px",
                        }}
                        className="animable"
                    />
                </g>
            </g>
        </g>
    </svg>
)

export default SvgComponent
